// Interview page translations
export const interviewTranslations = {
  en: {
    title: "Interview",
    note: "Please click 'Start Answer' to begin responding. Click 'End Answer' to submit your answer. Click 'End Interview' to finish the interview.",
    basicInfo: "Basic Information",
        controls: {
      startInterview: "Start Interview",
      endInterview: "End Interview",
      startAnswer: "Start Answer",
      endAnswer: "End Answer",
      recording: "Recording...",
      skipForm: "Skip Form",
      starting: "Starting...",
      typeMessage: "Type your message...",
      send: "Send",
      sending: "Sending..."
    },
    video: {
      turnOn: "Turn on Camera",
      turnOff: "Turn off Video Preview",
      stopRecording: "Stop Camera"
    },
    status: {
      connectionLost: "Connection lost. Please refresh the page and try again.",
      elapsedTime: "Elapsed Time",
      status: "Status",
      mode: "Mode",
      audioInterview: "Audio Interview",
      connected: "Connected",
      connecting: "Connecting...",
      ended: "Interview Ended",
      ready: "Ready",
      recording: "Recording",
      transcribing: "Transcribing...",
      aiSpeaking: "AI Speaking",
      recordingAudio: "Recording Audio",
      youAreSpeaking: "You are speaking...",
      aiIsSpeaking: "AI is speaking...",
      processing: "Processing...",
      listening: "Listening...",
      preparingInterview: "Preparing interview...",
      interviewComplete: "Interview Complete"
    },
    messages: {
      typing: "AI Interviewer is typing...",
      aiInterviewer: "AI Interviewer",
      interviewee: "Interviewee",
      recording: "Recording voice message",
      welcome: "Hello! Please let me know when you are ready to begin.",
      loadError: "Hello! There was an issue loading the interview project, but you may continue browsing the page or try refreshing.",
      startFailed: "Failed to start the interview.",
      loadFailed: "Failed to load the interview project; please check if the link is correct.",
      transcribing: "Transcribing",
      messageCount: "{{count}} messages",
      you: "You",
      aiInterviewer: "AI Interviewer",
      interviewInProgress: "Audio interview in progress. Start speaking to begin...",
      clickToStart: "Click \"Start Interview\" to begin the conversation."
    },
    fields: {
      name: "Name",
      age: "Age",
      gender: "Gender",
      occupation: "Occupation",
      education: "Education Level",
      contact: "Contact Information",
      platformId: "Platform ID (if any)",
      notes: "Notes"
    },
    // Individual field shortcuts for convenience
    name: "Name",
    age: "Age",
    gender: "Gender",
    education: "Education",
    occupation: "Occupation",
    contact: "Contact",
    notes: "Notes",
    // Gender options
    gender: {
      male: "Male",
      female: "Female",
      other: "Other"
    },
    male: "Male",
    female: "Female",
    other: "Other",
    consentText: "I consent to participate in this interview",
    recordingNotice: "This interview may be recorded for research purposes.",
    recordingActive: "This interview is being recorded",
    startInterview: "Start Interview",
    sections: {
      interviewLog: "Interview Log",
      interviewConversation: "Interview Conversation"
    },
    welcome2: "Hello, please let me know when you are ready to begin the interview.",
    warnings: {
      timeRunningOut: "Warning: Interview will end in 1 minute",
      audioRecorded: "Please note: Your voice responses will be recorded and stored.",
      textOnly: "Your responses will be transcribed to text only. Original voice recordings will not be stored.",
      audioInterviewActive: "Audio Interview Active: The AI can hear you speaking. No need to press any buttons - just speak naturally and the AI will respond with voice first, then show the text.",
      audioRecording: "📹 Audio Recording: Your audio is being recorded for research purposes.",
      audioWillRecord: "⚠️ This interview will record audio. Starting the interview indicates your consent to recording."
    },
    timeUp: {
      title: "Interview Time Limit Reached",
      message: "The interview has reached its maximum duration of {{duration}} minutes and has been automatically ended."
    },
    info: {
      language: "Interview language: {{language}}",
      engineUsed: "Transcription engine used: {{engine}}"
    },
    transcriptionEngine: {
      confirmXunfei: "Use Xunfei for transcription? It is more accurate but slower. Click OK for Xunfei, or Cancel to stay with Whisper (faster, default)."
    },
    consent: {
      checkbox: "I consent to participate in this interview",
      description: "By checking this box, you agree to participate in this research interview and acknowledge that your responses will be recorded and used for research purposes.",
      twinCheckbox: "I consent to my data being used to create an AI persona for future research",
      twinDescription: "This allows researchers to create a digital version of your interview responses for follow-up studies. Your identity will remain anonymous."
    },
    help: {
      microphonePermission: "Having trouble starting the interview? Check if microphone permission is enabled. Look for the icon near the website URL in your browser and click it to grant permission. Please do not use Firefox browser."
    },
    errors: {
      realtimeNotAvailable: "Real-time audio not available, cannot proceed with audio interview",
      testFailed: "Test failed",
      noAudioTracks: "No audio tracks found",
      micAccessFailed: "Microphone access failed",
      connectionError: "Connection error occurred",
      testError: "Test error",
      unknown: "Unknown error"
    },
    audioTest: {
      title: "Audio & Microphone Test",
      steps: "Test Steps:",
      step1: "1. Test microphone access",
      step2: "2. Connect to audio service", 
      step3: "3. Test AI assistant speech (listen for instructions)",
      step4: "4. Test your speech (speak when instructed)",
      description: "This test ensures your microphone and speakers are working correctly for the voice interview. The AI will speak first, then ask you to respond. Audio testing is required to ensure the best interview experience.",
      testInProgress: "Testing in progress...",
      startTest: "Start Audio Test",
      retryTest: "Retry Audio Test",
      testing: "Testing...",
      completed: "Test Completed",
      ready: "Ready to test audio and microphone",
      micAccess: "Testing microphone access...",
      connecting: "Getting session token...",
      establishing: "Connecting to audio service...",
      aiSpeaking: "Connection established. Starting assistant test...",
      userSpeak: "Assistant is speaking. Please say anything when you hear the instruction.",
      success: "Audio test successful! ✓ Microphone and speakers working correctly.",
      startInterview: "Start Interview"
    },
    languages: {
      english: "English",
      chinese: "Chinese",
      french: "French",
      norwegian: "Norwegian",
      dutch: "Dutch",
      german: "German",
      spanish: "Spanish",
      portuguese: "Portuguese",
      japanese: "Japanese",
      arabic: "Arabic",
      flexible: "Flexible"
    },
    voice: {
      enabled: "🔊 Voice playback is enabled. AI responses will be spoken aloud.",
      playing: "🎵 AI is speaking... (Click \"Start Answer\" to stop)",
      playButton: "🔊 Play",
      playingButton: "🔊 Playing",
      speaking: "🎵 Speaking..."
    },
    resume: {
      title: "Resume Previous Interview?",
      description: "We found a previous interview session that you can continue. Would you like to resume where you left off or start a new interview?",
      continue: "Continue This Interview",
      startNew: "Start New Interview"
    },
    hints: {
      recording: "🔴 Recording... Tap outside the conversation to stop",
      tapToSpeak: "👆 Tap outside the conversation to speak",
      typeBelow: "Type your response below",
      aiThinking: "AI is thinking...",
      aiSlowTip: "Taking longer than usual. If AI stays stuck, refresh the page — your progress is saved.",
      keepSpeaking: "Keep speaking... pause when done",
      listenToAI: "🔊 Listen to the AI interviewer...",
      processing: "⏳ Processing your response...",
      readyToListen: "Ready - start speaking anytime"
    },
    tips: {
      title: "💡 Tips & Troubleshooting",
      recordingIssue: "If recording stops unexpectedly, try refreshing the page and continuing the interview.",
      aiStuck: "If the AI seems stuck thinking for a long time, refresh the page to reconnect.",
      refreshNote: "Note: Your progress is saved automatically, so refreshing is safe."
    },
    voicePreTest: {
      title: "Device Check",
      subtitle: "Let's make sure your microphone is working before we start.",
      micTest: "Microphone",
      micTesting: "Checking access...",
      micOk: "Microphone detected ✓",
      micError: "Could not access microphone. Check browser permissions.",
      micIdle: "Waiting...",
      tip: "Make sure you are in a quiet environment and speak clearly.",
      retry: "Retry",
      back: "Back",
      startInterview: "Start Interview",
      startAnyway: "▶ Start Anyway"
    },
    interactionModes: {
      voiceToVoice: "Voice → Voice",
      voiceToText: "Voice → Text",
      textToVoice: "Text → Voice",
      textToText: "Text → Text"
    },
    thankYou: {
      title: "Thank You!",
      message: "Thank you for participating in this interview. Your responses have been saved successfully.",
      saved: "Conversation saved",
      recorded: "{{count}} messages recorded",
      duration: "Duration: {{minutes}}m {{seconds}}s",
      returnHome: "Return to Home"
    },
    csat: {
      title: "How was your experience?",
      subtitle: "Your feedback helps us improve. It only takes a moment.",
      stars: "stars",
      commentPlaceholder: "Anything you'd like to share? (optional)",
      submit: "Submit",
      skip: "Skip",
      thanks: "Thank you!",
      thanksDetail: "Your feedback has been recorded."
    },
    countdown: {
      warning: "Time is almost up!",
      remaining: "remaining"
    }
  },
  zh: {
    title: "访谈",
    note: "请点击开始回答按钮开始面试。请点击结束回答按钮提交答案。请点击结束面试按钮结束面试。",
    basicInfo: "基本信息",
    controls: {
      startInterview: "开始访谈",
      endInterview: "结束访谈",
      startAnswer: "开始回答",
      endAnswer: "结束回答",
      recording: "录制中...",
      skipForm: "跳过表单",
      starting: "启动中...",
      typeMessage: "输入您的消息...",
      send: "发送",
      sending: "发送中..."
    },
    video: {
      turnOn: "打开摄像头",
      turnOff: "关闭视频预览",
      stopRecording: "关闭摄像头"
    },
    status: {
      connectionLost: "连接丢失。请刷新页面并重试。",
      elapsedTime: "已用时间",
      status: "状态",
      mode: "模式",
      audioInterview: "音频访谈",
      connected: "已连接",
      connecting: "连接中...",
      ended: "访谈已结束",
      ready: "准备就绪",
      recording: "录音中",
      transcribing: "转录中...",
      aiSpeaking: "AI说话中",
      recordingAudio: "音频存储中",
      youAreSpeaking: "您正在说话...",
      aiIsSpeaking: "AI正在说话...",
      processing: "处理中...",
      listening: "正在聆听...",
      preparingInterview: "准备访谈中...",
      interviewComplete: "访谈完成"
    },
    messages: {
      typing: "AI访谈员正在输入...",
      aiInterviewer: "AI访谈员",
      interviewee: "受访者",
      recording: "正在录制语音消息",
      welcome: "您好！请告诉我您何时准备开始。",
      loadError: "您好！加载访谈项目时出现问题，但您可以继续浏览页面或尝试刷新。",
      startFailed: "启动访谈失败。",
      loadFailed: "加载访谈项目失败；请检查链接是否正确。",
      transcribing: "正在转录...",
      messageCount: "{{count}} 条消息",
      you: "您",
      interviewInProgress: "音频访谈进行中。开始说话以开始对话...",
      clickToStart: "点击\"开始访谈\"开始对话。"
    },
    fields: {
      name: "姓名",
      age: "年龄",
      gender: "性别",
      occupation: "职业",
      education: "教育水平",
      contact: "联系方式",
      platformId: "平台ID（如有）",
      notes: "备注"
    },
    // Individual field shortcuts for convenience
    name: "姓名",
    age: "年龄",
    gender: "性别",
    education: "教育背景",
    occupation: "职业",
    contact: "联系方式",
    notes: "备注",
    // Gender options
    gender: {
      male: "男",
      female: "女",
      other: "其他"
    },
    male: "男",
    female: "女",
    other: "其他",
    consentText: "我同意参与此次访谈",
    recordingNotice: "此次访谈可能会被录制用于研究目的。",
    recordingActive: "此次访谈正在被录音",
    startInterview: "开始访谈",
    sections: {
      interviewLog: "访谈记录",
      interviewConversation: "访谈对话"
    },
    welcome2: "您好，请告诉我您是否准备好开始访谈。",
    timeUp: {
      title: "访谈时间已达上限",
      message: "访谈已达到最长时限{{duration}}分钟，已自动结束。"
    },
    warnings: {
      timeRunningOut: "警告：访谈将在1分钟后结束",
      audioRecorded: "请注意：您的语音回答将被录制并存储。",
      textOnly: "您的回答将只被转录为文字。原始语音不会被保存。",
      audioInterviewActive: "音频访谈激活：AI可以听到您的说话。无需按任何按钮 - 只需自然说话，AI将首先用语音回应，然后显示文本。",
      audioRecording: "📹 音频录制：您的音频将被记录以供研究目的。",
      audioWillRecord: "⚠️ 此访谈将录制音频。开始访谈即表示您同意录音。"
    },
    info: {
      language: "访谈语言：{{language}}",
      engineUsed: "转写引擎：{{engine}}"
    },
    transcriptionEngine: {
      confirmXunfei: "是否使用讯飞转写？讯飞更准确但速度稍慢。点击“确定”使用讯飞，点击“取消”继续使用默认的 Whisper（更快）。"
    },
    consent: {
      checkbox: "我同意参与本次访谈",
      description: "勾选此框即表示您同意参与本次研究访谈，并了解您的回答将被记录并用于研究目的。",
      twinCheckbox: "我同意将我的数据用于创建AI人物以供未来研究",
      twinDescription: "这允许研究人员根据您的访谈回答创建数字版本用于后续研究。您的身份将保持匿名。"
    },
    help: {
      microphonePermission: "启动访谈时遇到问题？检查是否启用了麦克风权限。在浏览器中查找网站URL附近的图标并点击它以授予权限。请不要使用Firefox浏览器。"
    },
    errors: {
      realtimeNotAvailable: "实时音频不可用，无法进行音频访谈",
      testFailed: "测试失败",
      noAudioTracks: "未找到音频轨道",
      micAccessFailed: "麦克风权限失败",
      connectionError: "连接错误发生",
      testError: "测试错误",
      unknown: "未知错误"
    },
    audioTest: {
      title: "音频和麦克风测试",
      steps: "测试步骤：",
      step1: "1. 测试麦克风权限",
      step2: "2. 连接音频服务",
      step3: "3. 测试AI助手语音（听取指示）",
      step4: "4. 测试您的语音（按指示说话）",
      description: "此测试确保您的麦克风和扬声器能正常工作进行语音访谈。AI将首先说话，然后要求您回应。音频测试是必需的，以确保最佳的访谈体验。",
      testInProgress: "测试进行中...",
      startTest: "开始音频测试",
      retryTest: "重试音频测试",
      testing: "测试中...",
      completed: "测试完成",
      ready: "准备测试音频和麦克风",
      micAccess: "正在测试麦克风权限...",
      connecting: "正在获取会话令牌...",
      establishing: "正在连接音频服务...",
      aiSpeaking: "连接已建立。开始助手测试...",
      userSpeak: "助手正在说话。听到指示后请说任何内容。",
      success: "音频测试成功！✓ 麦克风和扬声器工作正常。",
      startInterview: "开始访谈"
    },
    languages: {
      english: "英语",
      chinese: "中文",
      french: "法语",
      norwegian: "挪威语",
      dutch: "荷兰语",
      german: "德语",
      spanish: "西班牙语",
      portuguese: "葡萄牙语",
      japanese: "日语",
      arabic: "阿拉伯语",
      flexible: "灵活"
    },
    voice: {
      enabled: "🔊 语音播放已启用。AI回答将朗读出来。",
      playing: "🎵 AI正在说话...(点击\"开始回答\"停止)",
      playButton: "🔊 播放",
      playingButton: "🔊 播放中",
      speaking: "🎵 播放中..."
    },
    resume: {
      title: "恢复之前的访谈？",
      description: "我们发现了一个可以继续的访谈会话。您想要从上次停止的地方继续，还是开始一个新的访谈？",
      continue: "继续此访谈",
      startNew: "开始新访谈"
    },
    hints: {
      recording: "🔴 录音中... 点击对话区域外停止",
      tapToSpeak: "👆 点击对话区域外开始说话",
      typeBelow: "在下方输入您的回答",
      aiThinking: "AI正在思考...",
      aiSlowTip: "响应时间较长。如果AI持续卡住，请刷新页面——您的进度已自动保存。",
      keepSpeaking: "请继续说话... 说完后暂停",
      listenToAI: "🔊 请聆听AI访谈员...",
      processing: "⏳ 正在处理您的回答...",
      readyToListen: "准备就绪 - 随时可以开始说话"
    },
    tips: {
      title: "💡 提示与故障排除",
      recordingIssue: "如果录音意外停止，请刷新页面并继续访谈。",
      aiStuck: "如果AI长时间显示\"正在思考\"，请刷新页面重新连接。",
      refreshNote: "注意：您的进度会自动保存，刷新页面是安全的。"
    },
    voicePreTest: {
      title: "设备检测",
      subtitle: "开始前，我们先确认您的麦克风工作正常。",
      micTest: "麦克风",
      micTesting: "正在检测...",
      micOk: "麦克风已检测到 ✓",
      micError: "无法访问麦克风，请检查浏览器权限。",
      micIdle: "等待中...",
      tip: "请确保在安静的环境中，清晰地说话。",
      retry: "重试",
      back: "返回",
      startInterview: "开始访谈",
      startAnyway: "▶ 直接开始"
    },
    interactionModes: {
      voiceToVoice: "语音 → 语音",
      voiceToText: "语音 → 文字",
      textToVoice: "文字 → 语音",
      textToText: "文字 → 文字"
    },
    thankYou: {
      title: "感谢您！",
      message: "感谢您参与本次访谈。您的回答已成功保存。",
      saved: "对话已保存",
      recorded: "已记录 {{count}} 条消息",
      duration: "时长：{{minutes}}分{{seconds}}秒",
      returnHome: "返回首页"
    },
    csat: {
      title: "您的体验如何？",
      subtitle: "您的反馈将帮助我们改进，只需几秒钟。",
      stars: "星",
      commentPlaceholder: "有什么想分享的吗？（可选）",
      submit: "提交",
      skip: "跳过",
      thanks: "谢谢！",
      thanksDetail: "您的反馈已记录。"
    },
    countdown: {
      warning: "时间即将结束！",
      remaining: "剩余"
    }
  },
  fr: {
    title: "Entretien",
    note: "Veuillez cliquer sur « Démarrer la réponse » pour commencer à répondre. Cliquez sur « Terminer la réponse » pour soumettre votre réponse. Cliquez sur « Terminer l'entretien » pour mettre fin à l'entretien.",
    basicInfo: "Informations de base",
    controls: {
      startInterview: "Démarrer l'entretien",
      endInterview: "Terminer l'entretien",
      startAnswer: "Démarrer la réponse",
      endAnswer: "Terminer la réponse",
      recording: "Enregistrement...",
      skipForm: "Ignorer le formulaire",
      starting: "Démarrage...",
      typeMessage: "Tapez votre message...",
      send: "Envoyer",
      sending: "Envoi en cours..."
    },
    video: {
      turnOn: "Activer la caméra",
      turnOff: "Désactiver l'aperçu vidéo",
      stopRecording: "Arrêter la caméra"
    },
    status: {
      connectionLost: "Connexion perdue. Veuillez rafraîchir la page et réessayer.",
      elapsedTime: "Temps écoulé",
      status: "Statut",
      mode: "Mode",
      audioInterview: "Entretien Audio",
      connected: "Connecté",
      connecting: "Connexion...",
      ended: "Entretien terminé",
      ready: "Prêt",
      recording: "Enregistrement",
      transcribing: "Transcription...",
      aiSpeaking: "IA parle",
      recordingAudio: "Enregistrement audio",
      youAreSpeaking: "Vous parlez...",
      aiIsSpeaking: "L'IA parle...",
      processing: "Traitement...",
      listening: "Écoute...",
      preparingInterview: "Préparation de l'entretien...",
      interviewComplete: "Entretien terminé"
    },
    messages: {
      typing: "L'intervieweur IA tape...",
      aiInterviewer: "Intervieweur IA",
      interviewee: "Interviewé(e)",
      recording: "Enregistrement du message vocal",
      welcome: "Bonjour ! Veuillez me faire savoir quand vous êtes prêt(e) à commencer.",
      loadError: "Bonjour ! Il y a eu un problème lors du chargement du projet d'entretien, mais vous pouvez continuer à naviguer sur la page ou essayer de rafraîchir.",
      startFailed: "Impossible de démarrer l'entretien.",
      loadFailed: "Impossible de charger le projet d'entretien ; veuillez vérifier si le lien est correct.",
      transcribing: "Transcription en cours...",
      messageCount: "{{count}} messages",
      you: "Vous",
      interviewInProgress: "Entretien audio en cours. Commencez à parler pour débuter...",
      clickToStart: "Cliquez sur \"Commencer l'entretien\" pour débuter la conversation."
    },
    fields: {
      name: "Nom",
      age: "Âge",
      gender: "Genre",
      occupation: "Profession",
      education: "Niveau d'éducation",
      contact: "Informations de contact",
      platformId: "ID de plateforme (le cas échéant)",
      notes: "Notes"
    },
    // Individual field shortcuts for convenience
    name: "Nom",
    age: "Âge",
    gender: "Genre",
    education: "Éducation",
    occupation: "Profession",
    contact: "Contact",
    notes: "Notes",
    // Gender options
    gender: {
      male: "Homme",
      female: "Femme",
      other: "Autre"
    },
    male: "Homme",
    female: "Femme",
    other: "Autre",
    consentText: "Je consens à participer à cet entretien",
    recordingNotice: "Cet entretien peut être enregistré à des fins de recherche.",
    recordingActive: "Cet entretien est en cours d'enregistrement",
    startInterview: "Commencer l'entretien",
    sections: {
      interviewLog: "Journal d'entretien",
      interviewConversation: "Conversation d'entretien"
    },
    welcome2: "Bonjour, faites-moi savoir si vous êtes prêt(e) à commencer l'entretien.",
    timeUp: {
      title: "Limite de temps d'entretien atteinte",
      message: "L'entretien a atteint sa durée maximale de {{duration}} minutes et s'est automatiquement terminé."
    },
    warnings: {
      timeRunningOut: "Attention : L'entretien se terminera dans 1 minute",
      audioRecorded: "Veuillez noter : Vos réponses vocales seront enregistrées et stockées.",
      textOnly: "Vos réponses seront transcrites en texte uniquement. Les enregistrements vocaux originaux ne seront pas conservés.",
      audioInterviewActive: "Entretien audio actif : L'IA peut vous entendre parler. Pas besoin d'appuyer sur des boutons - parlez naturellement et l'IA répondra d'abord par la voix, puis affichera le texte.",
      audioRecording: "📹 Enregistrement audio : Votre audio est enregistré à des fins de recherche.",
      audioWillRecord: "⚠️ Cet entretien enregistrera l'audio. Commencer l'entretien indique votre consentement à l'enregistrement."
    },
    info: {
      language: "Langue d'entretien : {{language}}",
      engineUsed: "Moteur de transcription utilisé : {{engine}}"
    },
    transcriptionEngine: {
      confirmXunfei: "Utiliser Xunfei pour la transcription ? Plus précis mais plus lent. Cliquez sur OK pour Xunfei, ou sur Annuler pour rester sur Whisper (plus rapide, par défaut)."
    },
    consent: {
      checkbox: "Je consens à participer à cet entretien",
      description: "En cochant cette case, vous acceptez de participer à cet entretien de recherche et reconnaissez que vos réponses seront enregistrées et utilisées à des fins de recherche.",
      twinCheckbox: "Je consens à ce que mes données soient utilisées pour créer un personnage IA pour de futures recherches",
      twinDescription: "Cela permet aux chercheurs de créer une version numérique de vos réponses d'entretien pour des études de suivi. Votre identité restera anonyme."
    },
    help: {
      microphonePermission: "Problèmes pour démarrer l'entretien ? Vérifiez si l'autorisation du microphone est activée. Recherchez l'icône près de l'URL du site Web dans votre navigateur et cliquez dessus pour accorder l'autorisation. Veuillez ne pas utiliser le navigateur Firefox."
    },
    errors: {
      realtimeNotAvailable: "Audio en temps réel non disponible, impossible de procéder à l'entretien audio",
      testFailed: "Test échoué",
      noAudioTracks: "Aucune piste audio trouvée",
      micAccessFailed: "Échec de l'accès au microphone",
      connectionError: "Erreur de connexion survenue",
      testError: "Erreur de test",
      unknown: "Erreur inconnue"
    },
    audioTest: {
      title: "Test Audio et Microphone",
      steps: "Étapes du test :",
      step1: "1. Tester l'accès au microphone",
      step2: "2. Se connecter au service audio",
      step3: "3. Tester la voix de l'assistant IA (écouter les instructions)",
      step4: "4. Testez votre voix (parlez quand demandé)",
      description: "Ce test garantit que votre microphone et vos haut-parleurs fonctionnent correctement pour l'entretien vocal. L'IA parlera d'abord, puis vous demandera de répondre. Le test audio est requis pour assurer la meilleure expérience d'entretien.",
      testInProgress: "Test en cours...",
      startTest: "Commencer le test audio",
      retryTest: "Réessayer le test audio",
      testing: "Test en cours...",
      completed: "Test terminé",
      ready: "Prêt à tester l'audio et le microphone",
      micAccess: "Test de l'accès au microphone...",
      connecting: "Obtention du jeton de session...",
      establishing: "Connexion au service audio...",
      aiSpeaking: "Connexion établie. Début du test de l'assistant...",
      userSpeak: "L'assistant parle. Veuillez dire quelque chose quand vous entendez l'instruction.",
      success: "Test audio réussi ! ✓ Microphone et haut-parleurs fonctionnent correctement.",
      startInterview: "Démarrer l'entretien"
    },
    languages: {
      english: "Anglais",
      chinese: "Chinois",
      french: "Français",
      norwegian: "Norvégien",
      dutch: "Néerlandais",
      german: "Allemand",
      spanish: "Espagnol",
      portuguese: "Portugais",
      japanese: "Japonais",
      arabic: "Arabe",
      flexible: "Flexible"
    },
    voice: {
      enabled: "🔊 Lecture vocale activée. Les réponses de l'IA seront lues à haute voix.",
      playing: "🎵 L'IA parle... (Cliquez sur \"Commencer la réponse\" pour arrêter)",
      playButton: "🔊 Lire",
      playingButton: "🔊 En cours",
      speaking: "🎵 Parle..."
    },
    resume: {
      title: "Reprendre l'entretien précédent ?",
      description: "Nous avons trouvé une session d'entretien précédente que vous pouvez continuer. Souhaitez-vous reprendre où vous vous êtes arrêté ou commencer un nouvel entretien ?",
      continue: "Continuer cet entretien",
      startNew: "Commencer un nouvel entretien"
    },
    hints: {
      recording: "🔴 Enregistrement... Appuyez en dehors de la conversation pour arrêter",
      tapToSpeak: "👆 Appuyez en dehors de la conversation pour parler",
      typeBelow: "Tapez votre réponse ci-dessous",
      aiThinking: "L'IA réfléchit...",
      aiSlowTip: "Cela prend plus de temps que prévu. Si l'IA reste bloquée, actualisez la page — votre progression est sauvegardée.",
      keepSpeaking: "Continuez à parler... faites une pause quand vous avez terminé",
      listenToAI: "🔊 Écoutez l'intervieweur IA...",
      processing: "⏳ Traitement de votre réponse...",
      readyToListen: "Prêt - commencez à parler quand vous voulez"
    },
    tips: {
      title: "💡 Conseils et dépannage",
      recordingIssue: "Si l'enregistrement s'arrête de manière inattendue, essayez d'actualiser la page et de continuer l'entretien.",
      aiStuck: "Si l'IA semble bloquée en train de réfléchir pendant longtemps, actualisez la page pour vous reconnecter.",
      refreshNote: "Note : Votre progression est enregistrée automatiquement, l'actualisation est donc sûre."
    },
    voicePreTest: {
      title: "Vérification de l'appareil",
      subtitle: "Vérifions que votre microphone fonctionne avant de commencer.",
      micTest: "Microphone",
      micTesting: "Vérification en cours...",
      micOk: "Microphone détecté ✓",
      micError: "Impossible d'accéder au microphone. Vérifiez les permissions du navigateur.",
      micIdle: "En attente...",
      tip: "Assurez-vous d'être dans un environnement calme et de parler clairement.",
      retry: "Réessayer",
      back: "Retour",
      startInterview: "Démarrer l'entretien",
      startAnyway: "▶ Démarrer quand même"
    },
    interactionModes: {
      voiceToVoice: "Voix → Voix",
      voiceToText: "Voix → Texte",
      textToVoice: "Texte → Voix",
      textToText: "Texte → Texte"
    },
    thankYou: {
      title: "Merci !",
      message: "Merci d'avoir participé à cet entretien. Vos réponses ont été enregistrées avec succès.",
      saved: "Conversation enregistrée",
      recorded: "{{count}} messages enregistrés",
      duration: "Durée : {{minutes}}m {{seconds}}s",
      returnHome: "Retour à l'accueil"
    },
    csat: {
      title: "Comment s'est passée votre expérience ?",
      subtitle: "Vos commentaires nous aident à nous améliorer. Cela ne prend qu'un instant.",
      stars: "étoiles",
      commentPlaceholder: "Quelque chose à partager ? (facultatif)",
      submit: "Envoyer",
      skip: "Passer",
      thanks: "Merci !",
      thanksDetail: "Vos commentaires ont bien été enregistrés."
    },
    countdown: {
      warning: "Le temps est presque écoulé !",
      remaining: "restant"
    }
  },
  nb: {
    title: "Intervju",
    note: "Vennligst klikk på start svar-knappen for å begynne intervjuet. Vennligst klikk på avslutt svar-knappen for å sende inn svaret. Vennligst klikk på avslutt intervju-knappen for å avslutte intervjuet.",
    basicInfo: "Grunnleggende informasjon",
    controls: {
      startInterview: "Start intervju",
      endInterview: "Avslutt intervju",
      startAnswer: "Start svar",
      endAnswer: "Avslutt svar",
      recording: "Tar opp...",
      skipForm: "Hopp over skjema",
      starting: "Starter...",
      typeMessage: "Skriv meldingen din...",
      send: "Send",
      sending: "Sender..."
    },
    video: {
      turnOn: "Slå på kamera",
      turnOff: "Slå av videoforhåndsvisning",
      stopRecording: "Stopp videoopptak"
    },
    status: {
      connectionLost: "Tilkobling tapt. Vennligst oppdater siden og prøv igjen.",
      elapsedTime: "Medgått tid",
      status: "Status",
      mode: "Modus",
      audioInterview: "Lydintervju",
      connected: "Tilkoblet",
      connecting: "Kobler til...",
      ended: "Intervju avsluttet",
      ready: "Klar",
      recording: "Opptaker",
      transcribing: "Transkriberer...",
      aiSpeaking: "AI snakker",
      recordingAudio: "Lydopptak",
      youAreSpeaking: "Du snakker...",
      aiIsSpeaking: "AI snakker...",
      processing: "Behandler...",
      listening: "Lytter...",
      preparingInterview: "Forbereder intervju...",
      interviewComplete: "Intervju fullført"
    },
    messages: {
      typing: "KI-intervjuer skriver...",
      aiInterviewer: "KI-intervjuer",
      interviewee: "Intervjuobjekt",
      recording: "Tar opp talemelding",
      welcome: "Hei! Vennligst la meg vite når du er klar til å begynne.",
      loadError: "Hei! Det oppsto et problem med å laste intervjuprosjektet, men du kan fortsette å bla gjennom siden eller prøve å oppdatere.",
      startFailed: "Kunne ikke starte intervjuet.",
      loadFailed: "Kunne ikke laste intervjuprosjektet; vennligst sjekk om lenken er riktig.",
      transcribing: "Transkriberer",
      messageCount: "{{count}} meldinger",
      you: "Du",
      interviewInProgress: "Lydintervju pågår. Start å snakke for å begynne...",
      clickToStart: "Klikk \"Start intervju\" for å begynne samtalen."
    },
    fields: {
      name: "Navn",
      age: "Alder",
      gender: "Kjønn",
      occupation: "Yrke",
      education: "Utdanningsnivå",
      contact: "Kontaktinformasjon",
      platformId: "Plattform-ID (hvis noen)",
      notes: "Notater"
    },
    // Individual field shortcuts for convenience
    name: "Navn",
    age: "Alder",
    gender: "Kjønn",
    education: "Utdanning",
    occupation: "Yrke",
    contact: "Kontakt",
    notes: "Notater",
    // Gender options
    gender: {
      male: "Mann",
      female: "Kvinne",
      other: "Annet"
    },
    male: "Mann",
    female: "Kvinne",
    other: "Annet",
    consentText: "Jeg samtykker til å delta i dette intervjuet",
    recordingNotice: "Dette intervjuet kan bli tatt opp for forskningsformål.",
    recordingActive: "Dette intervjuet blir tatt opp",
    startInterview: "Start intervju",
    sections: {
      interviewLog: "Intervjulogg",
      interviewConversation: "Intervjusamtale"
    },
    welcome2: "Hei, vennligst gi meg beskjed når du er klar til å begynne intervjuet.",
    warnings: {
      timeRunningOut: "Advarsel: Intervjuet avsluttes om 1 minutt",
      microphonePermission: "Problemer med å starte intervjuet? Sjekk om mikrofontillatelse er aktivert. Se etter ikonet nær nettstedets URL i nettleseren din og klikk på det for å gi tillatelse. Vennligst ikke bruk Firefox-nettleseren.",
      audioRecorded: "Vennligst merk: Dine talesvar vil bli tatt opp og lagret.",
      textOnly: "Dine svar vil bli transkribert til bare tekst. Opprinnelige taleopptakene vil ikke bli lagret.",
      audioInterviewActive: "Lydintervju aktivt: AI-en kan høre deg snakke. Ingen knapper å trykke - bare snakk naturlig og AI-en vil svare med stemme først, deretter vise teksten.",
      audioRecording: "📹 Lydopptak: Din lyd blir tatt opp for forskningsformål.",
      audioWillRecord: "⚠️ Dette intervjuet vil ta opp lyd. Å starte intervjuet indikerer ditt samtykke til opptak."
    },
    timeUp: {
      title: "Intervjutidsgrense nådd",
      message: "Intervjuet har nådd sin maksimale varighet på {{duration}} minutter og har blitt automatisk avsluttet."
    },
    info: {
      language: "Intervjuspråk: {{language}}",
      engineUsed: "Transkripsjonsmotoren brukt: {{engine}}"
    },
    transcriptionEngine: {
      confirmXunfei: "Bruke Xunfei for transkripsjon? Mer nøyaktig men tregere. Klikk OK for Xunfei, eller Avbryt for å beholde Whisper (raskere, standard)."
    },
    consent: {
      checkbox: "Jeg samtykker til å delta i dette intervjuet",
      description: "Ved å krysse av denne boksen godtar du å delta i dette forskningsintervjuet og erkjenner at svarene dine vil bli tatt opp og brukt til forskningsformål.",
      twinCheckbox: "Jeg samtykker til at dataene mine brukes til å opprette en AI-persona for fremtidig forskning",
      twinDescription: "Dette lar forskere lage en digital versjon av dine intervjusvar for oppfølgingsstudier. Din identitet vil forbli anonym."
    },
    help: {
      microphonePermission: "Problemer med å starte intervjuet? Sjekk om mikrofontillatelse er aktivert. Se etter ikonet nær nettstedets URL i nettleseren din og klikk på det for å gi tillatelse. Vennligst ikke bruk Firefox-nettleseren."
    },
    errors: {
      realtimeNotAvailable: "Sanntidslyd ikke tilgjengelig, kan ikke fortsette med lydintervju",
      testFailed: "Test mislyktes",
      noAudioTracks: "Ingen lydspor funnet",
      micAccessFailed: "Mikrofontilgang mislyktes",
      connectionError: "Tilkoblingsfeil oppstod",
      testError: "Testfeil",
      unknown: "Ukjent feil"
    },
    audioTest: {
      title: "Lyd- og mikrofontest",
      steps: "Test-trinn:",
      step1: "1. Test mikrofontilgang",
      step2: "2. Koble til lydtjeneste",
      step3: "3. Test AI-assistentens tale (lytt til instruksjoner)",
      step4: "4. Test din tale (snakk når du får beskjed)",
      description: "Denne testen sikrer at mikrofonen og høyttalerne fungerer riktig for stemmeintervjuet. AI-en vil snakke først, deretter be deg svare. Lydtesting er påkrevd for å sikre den beste intervjuopplevelsen.",
      testInProgress: "Test pågår...",
      startTest: "Start lydtest",
      retryTest: "Prøv lydtest på nytt",
      testing: "Tester...",
      completed: "Test fullført",
      ready: "Klar til å teste lyd og mikrofon",
      micAccess: "Tester mikrofontilgang...",
      connecting: "Henter økttoken...",
      establishing: "Kobler til lydtjeneste...",
      aiSpeaking: "Tilkobling etablert. Starter assistenttest...",
      userSpeak: "Assistenten snakker. Vennligst si noe når du hører instruksjonen.",
      success: "Lydtest vellykket! ✓ Microfoon og høyttalere fungerer riktig.",
      startInterview: "Start intervjuet"
    },
    languages: {
      english: "Engelsk",
      chinese: "Kinesisk",
      french: "Fransk",
      norwegian: "Norsk",
      dutch: "Nederlandsk",
      german: "Tysk",
      spanish: "Spansk",
      portuguese: "Portugisisk",
      japanese: "Japansk",
      arabic: "Arabisk",
      flexible: "Fleksibel"
    },
    voice: {
      enabled: "🔊 Stemmeavspilling aktivert. AI-svar vil bli lest høyt.",
      playing: "🎵 AI snakker... (Klikk \"Start svar\" for å stoppe)",
      playButton: "🔊 Spill av",
      playingButton: "🔊 Spiller av",
      speaking: "🎵 Snakker..."
    },
    resume: {
      title: "Gjenoppta forrige intervju?",
      description: "Vi fant en tidligere intervjusesjon som du kan fortsette. Vil du gjenoppta der du slapp eller starte et nytt intervju?",
      continue: "Fortsett dette intervjuet",
      startNew: "Start nytt intervju"
    },
    hints: {
      recording: "🔴 Tar opp... Trykk utenfor samtalen for å stoppe",
      tapToSpeak: "👆 Trykk utenfor samtalen for å snakke",
      typeBelow: "Skriv svaret ditt nedenfor",
      aiThinking: "AI tenker...",
      aiSlowTip: "Tar lengre tid enn vanlig. Hvis AI-en henger seg, oppdater siden — fremgangen din er lagret.",
      keepSpeaking: "Fortsett å snakke... pause når du er ferdig",
      listenToAI: "🔊 Lytt til AI-intervjueren...",
      processing: "⏳ Behandler svaret ditt...",
      readyToListen: "Klar - begynn å snakke når som helst"
    },
    tips: {
      title: "💡 Tips og feilsøking",
      recordingIssue: "Hvis opptaket stopper uventet, prøv å oppdatere siden og fortsette intervjuet.",
      aiStuck: "Hvis AI-en ser ut til å være fast i tenkeprosessen i lang tid, oppdater siden for å koble til på nytt.",
      refreshNote: "Merk: Fremgangen din lagres automatisk, så oppdatering er trygt."
    },
    voicePreTest: {
      title: "Enhetssjekk",
      subtitle: "La oss sjekke at mikrofonen din fungerer før vi starter.",
      micTest: "Mikrofon",
      micTesting: "Sjekker tilgang...",
      micOk: "Mikrofon oppdaget ✓",
      micError: "Kunne ikke få tilgang til mikrofonen. Sjekk nettleserrettigheter.",
      micIdle: "Venter...",
      tip: "Sørg for at du er i et stille miljø og snakk tydelig.",
      retry: "Prøv igjen",
      back: "Tilbake",
      startInterview: "Start intervju",
      startAnyway: "▶ Start uansett"
    },
    interactionModes: {
      voiceToVoice: "Stemme → Stemme",
      voiceToText: "Stemme → Tekst",
      textToVoice: "Tekst → Stemme",
      textToText: "Tekst → Tekst"
    },
    thankYou: {
      title: "Takk!",
      message: "Takk for at du deltok i dette intervjuet. Svarene dine har blitt lagret.",
      saved: "Samtale lagret",
      recorded: "{{count}} meldinger registrert",
      duration: "Varighet: {{minutes}}m {{seconds}}s",
      returnHome: "Tilbake til forsiden"
    },
    csat: {
      title: "Hvordan var opplevelsen din?",
      subtitle: "Tilbakemeldingen din hjelper oss å bli bedre. Det tar bare et øyeblikk.",
      stars: "stjerner",
      commentPlaceholder: "Noe du vil dele? (valgfritt)",
      submit: "Send inn",
      skip: "Hopp over",
      thanks: "Takk!",
      thanksDetail: "Tilbakemeldingen din er registrert."
    },
    countdown: {
      warning: "Tiden er nesten ute!",
      remaining: "igjen"
    }
  },
  nl: {
    title: "Interview",
    note: "Klik op de 'Start Antwoord' knop om te beginnen met antwoorden. Klik op 'Beëindig Antwoord' om je antwoord in te dienen. Klik op 'Beëindig Interview' om het interview te beëindigen.",
    basicInfo: "Basisinformatie",
    controls: {
      startInterview: "Start Interview",
      endInterview: "Beëindig Interview",
      startAnswer: "Start Antwoord",
      endAnswer: "Beëindig Antwoord",
      recording: "Opnemen...",
      skipForm: "Formulier overslaan",
      starting: "Starten...",
      typeMessage: "Typ uw bericht...",
      send: "Verzenden",
      sending: "Verzenden..."
    },
    video: {
      turnOn: "Camera aanzetten",
      turnOff: "Videovoorvertoning uitzetten",
      stopRecording: "Stop video-opname"
    },
    status: {
      connectionLost: "Verbinding verloren. Vernieuw de pagina en probeer opnieuw.",
      elapsedTime: "Verstreken tijd",
      status: "Status",
      mode: "Modus",
      audioInterview: "Audio Interview",
      connected: "Verbonden",
      connecting: "Verbinden...",
      ended: "Interview beëindigd",
      ready: "Klaar",
      recording: "Opnemen",
      transcribing: "Transcriberen...",
      aiSpeaking: "AI spreekt",
      recordingAudio: "Audio opnemen",
      youAreSpeaking: "U spreekt...",
      aiIsSpeaking: "AI spreekt...",
      processing: "Verwerken...",
      listening: "Luisteren...",
      preparingInterview: "Interview voorbereiden...",
      interviewComplete: "Interview voltooid"
    },
    messages: {
      typing: "AI-interviewer typt...",
      aiInterviewer: "AI-interviewer",
      interviewee: "Geïnterviewde",
      recording: "Spraakbericht opnemen",
      welcome: "Hallo! Laat me weten wanneer je klaar bent om te beginnen.",
      loadError: "Hallo! Er was een probleem met het laden van het interviewproject, maar je kunt doorgaan met bladeren op de pagina of proberen te vernieuwen.",
      startFailed: "Kon het interview niet starten.",
      loadFailed: "Kon het interviewproject niet laden; controleer of de link correct is.",
      transcribing: "Transcriberen...",
      messageCount: "{{count}} berichten",
      you: "U",
      interviewInProgress: "Audio interview wordt uitgevoerd. Begin te praten om te starten...",
      clickToStart: "Klik \"Start interview\" om het gesprek te beginnen."
    },
    fields: {
      name: "Naam",
      age: "Leeftijd",
      gender: "Geslacht",
      occupation: "Beroep",
      education: "Onderwijsniveau",
      contact: "Contactinformatie",
      platformId: "Platform ID (indien van toepassing)",
      notes: "Notities"
    },
    // Individual field shortcuts for convenience
    name: "Naam",
    age: "Leeftijd",
    gender: "Geslacht",
    education: "Onderwijs",
    occupation: "Beroep",
    contact: "Contact",
    notes: "Notities",
    // Gender options
    gender: {
      male: "Man",
      female: "Vrouw",
      other: "Anders"
    },
    male: "Man",
    female: "Vrouw",
    other: "Anders",
    consentText: "Ik stem in met deelname aan dit interview",
    recordingNotice: "Dit interview kan worden opgenomen voor onderzoeksdoeleinden.",
    recordingActive: "Dit interview wordt opgenomen",
    startInterview: "Start interview",
    sections: {
      interviewLog: "Interviewlogboek",
      interviewConversation: "Interview gesprek"
    },
    welcome2: "Hallo, laat me weten of je klaar bent om het interview te beginnen.",
    timeUp: {
      title: "Interviewtijdlimiet bereikt",
      message: "Het interview heeft zijn maximale duur van {{duration}} minuten bereikt en is automatisch beëindigd."
    },
    warnings: {
      timeRunningOut: "Waarschuwing: Het interview eindigt over 1 minuut",
      audioRecorded: "Let op: Je spraakantwoorden worden opgenomen en opgeslagen.",
      textOnly: "Je antwoorden worden alleen getranscribeerd naar tekst. Originele spraakopnamen worden niet bewaard.",
      audioInterviewActive: "Audio interview actief: De AI kan u horen spreken. Geen knoppen indrukken nodig - spreek gewoon natuurlijk en de AI zal eerst met spraak reageren, dan de tekst tonen.",
      audioRecording: "📹 Audio-opname: Uw audio wordt opgenomen voor onderzoeksdoeleinden.",
      audioWillRecord: "⚠️ Dit interview zal audio opnemen. Het starten van het interview geeft uw toestemming voor opname aan."
    },
    info: {
      language: "Interviewtaal: {{language}}",
      engineUsed: "Gebruikte transcriptie-engine: {{engine}}"
    },
    transcriptionEngine: {
      confirmXunfei: "Xunfei gebruiken voor transcriptie? Nauwkeuriger maar langzamer. Klik OK voor Xunfei of Annuleren om bij Whisper te blijven (sneller, standaard)."
    },
    consent: {
      checkbox: "Ik stem in met deelname aan dit interview",
      description: "Door dit vakje aan te vinken, ga je akkoord met deelname aan dit onderzoeksinterview en erken je dat je antwoorden worden opgenomen en gebruikt voor onderzoeksdoeleinden.",
      twinCheckbox: "Ik stem in dat mijn gegevens worden gebruikt om een AI-persona te maken voor toekomstig onderzoek",
      twinDescription: "Dit stelt onderzoekers in staat een digitale versie van uw interviewantwoorden te maken voor vervolgstudies. Uw identiteit blijft anoniem."
    },
    help: {
      microphonePermission: "Problemen met het starten van het interview? Controleer of microfoontoestemming is ingeschakeld. Zoek naar het pictogram bij de website-URL in je browser en klik erop om toestemming te verlenen. Gebruik geen Firefox-browser."
    },
    errors: {
      realtimeNotAvailable: "Real-time audio niet beschikbaar, kan niet doorgaan met audio-interview",
      testFailed: "Test mislukt",
      noAudioTracks: "Geen audiosporen gevonden",
      micAccessFailed: "Microfoontoegang mislukt",
      connectionError: "Verbindingsfout opgetreden",
      testError: "Testfout",
      unknown: "Onbekende fout"
    },
    audioTest: {
      title: "Audio- en microfoontest",
      steps: "Teststappen:",
      step1: "1. Test microfoontoegang",
      step2: "2. Verbind met audioservice",
      step3: "3. Test AI-assistent spraak (luister naar instructies)",
      step4: "4. Test uw spraak (spreek wanneer gevraagd)",
      description: "Deze test zorgt ervoor dat uw microfoon en luidsprekers correct werken voor het spraakinterview. De AI zal eerst spreken en u vervolgens vragen te antwoorden. Audiotesten zijn vereist om de beste interview-ervaring te garanderen.",
      testInProgress: "Test wordt uitgevoerd...",
      startTest: "Start audiotest",
      retryTest: "Audiotest opnieuw proberen",
      testing: "Testen...",
      completed: "Test voltooid",
      ready: "Klaar om audio en microfoon te testen",
      micAccess: "Microfoontoegang testen...",
      connecting: "Sessietoken ophalen...",
      establishing: "Verbinden met audioservice...",
      aiSpeaking: "Verbinding tot stand gebracht. Assistenttest starten...",
      userSpeak: "Assistent spreekt. Zeg alsjeblieft iets wanneer je de instructie hoort.",
      success: "Audiotest succesvol! ✓ Microfoon en luidsprekers werken correct.",
      startInterview: "Interview starten"
    },
    languages: {
      english: "Engels",
      chinese: "Chinees",
      french: "Frans",
      norwegian: "Noors",
      dutch: "Nederlands",
      german: "Duits",
      spanish: "Spaans",
      portuguese: "Portugees",
      japanese: "Japans",
      arabic: "Arabisch",
      flexible: "Flexibel"
    },
    voice: {
      enabled: "🔊 Spraakweergave ingeschakeld. AI-antwoorden worden hardop voorgelezen.",
      playing: "🎵 AI spreekt... (Klik \"Start antwoord\" om te stoppen)",
      playButton: "🔊 Afspelen",
      playingButton: "🔊 Speelt af",
      speaking: "🎵 Spreekt..."
    },
    resume: {
      title: "Vorig interview hervatten?",
      description: "We hebben een eerdere interviewsessie gevonden die u kunt voortzetten. Wilt u hervatten waar u gebleven was of een nieuw interview starten?",
      continue: "Dit interview voortzetten",
      startNew: "Nieuw interview starten"
    },
    hints: {
      recording: "🔴 Opnemen... Tik buiten het gesprek om te stoppen",
      tapToSpeak: "👆 Tik buiten het gesprek om te spreken",
      typeBelow: "Typ uw antwoord hieronder",
      aiThinking: "AI is aan het denken...",
      aiSlowTip: "Duurt langer dan normaal. Als de AI vast zit, vernieuw de pagina — uw voortgang is opgeslagen.",
      keepSpeaking: "Blijf spreken... pauzeer wanneer klaar",
      listenToAI: "🔊 Luister naar de AI-interviewer...",
      processing: "⏳ Uw antwoord wordt verwerkt...",
      readyToListen: "Klaar - begin op elk moment te spreken"
    },
    tips: {
      title: "💡 Tips en probleemoplossing",
      recordingIssue: "Als de opname onverwacht stopt, probeer de pagina te vernieuwen en het interview voort te zetten.",
      aiStuck: "Als de AI lang lijkt te blijven hangen in het denkproces, vernieuw de pagina om opnieuw verbinding te maken.",
      refreshNote: "Opmerking: Uw voortgang wordt automatisch opgeslagen, dus vernieuwen is veilig."
    },
    voicePreTest: {
      title: "Apparaatcontrole",
      subtitle: "Laten we controleren of uw microfoon werkt voordat we beginnen.",
      micTest: "Microfoon",
      micTesting: "Toegang controleren...",
      micOk: "Microfoon gedetecteerd ✓",
      micError: "Geen toegang tot microfoon. Controleer browsermachtigingen.",
      micIdle: "Wachten...",
      tip: "Zorg dat u in een rustige omgeving bent en spreek duidelijk.",
      retry: "Opnieuw proberen",
      back: "Terug",
      startInterview: "Interview starten",
      startAnyway: "▶ Toch starten"
    },
    interactionModes: {
      voiceToVoice: "Stem → Stem",
      voiceToText: "Stem → Tekst",
      textToVoice: "Tekst → Stem",
      textToText: "Tekst → Tekst"
    },
    thankYou: {
      title: "Bedankt!",
      message: "Bedankt voor uw deelname aan dit interview. Uw antwoorden zijn succesvol opgeslagen.",
      saved: "Gesprek opgeslagen",
      recorded: "{{count}} berichten opgenomen",
      duration: "Duur: {{minutes}}m {{seconds}}s",
      returnHome: "Terug naar home"
    },
    csat: {
      title: "Hoe was uw ervaring?",
      subtitle: "Uw feedback helpt ons te verbeteren. Het kost maar een moment.",
      stars: "sterren",
      commentPlaceholder: "Wilt u iets delen? (optioneel)",
      submit: "Versturen",
      skip: "Overslaan",
      thanks: "Bedankt!",
      thanksDetail: "Uw feedback is geregistreerd."
    },
    countdown: {
      warning: "De tijd is bijna om!",
      remaining: "resterend"
    }
  },
  de: {
    title: "Interview",
    note: "Bitte klicken Sie auf 'Antwort starten', um mit der Beantwortung zu beginnen. Klicken Sie auf 'Antwort beenden', um Ihre Antwort zu übermitteln. Klicken Sie auf 'Interview beenden', um das Interview zu beenden.",
    basicInfo: "Grundlegende Informationen",
    controls: {
      startInterview: "Interview starten",
      endInterview: "Interview beenden",
      startAnswer: "Antwort starten",
      endAnswer: "Antwort beenden",
      recording: "Aufnahme läuft...",
      skipForm: "Formular überspringen",
      starting: "Startet...",
      typeMessage: "Geben Sie Ihre Nachricht ein...",
      send: "Senden",
      sending: "Sendet..."
    },
    video: {
      turnOn: "Kamera einschalten",
      turnOff: "Videovorschau ausschalten",
      stopRecording: "Kamera stoppen"
    },
    status: {
      connectionLost: "Verbindung verloren. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.",
      elapsedTime: "Verstrichene Zeit",
      status: "Status",
      mode: "Modus",
      audioInterview: "Audio-Interview",
      connected: "Verbunden",
      connecting: "Verbinde...",
      ended: "Interview beendet",
      ready: "Bereit",
      recording: "Aufnahme",
      transcribing: "Transkribiere...",
      aiSpeaking: "KI spricht",
      recordingAudio: "Audio aufnehmen",
      youAreSpeaking: "Sie sprechen...",
      aiIsSpeaking: "KI spricht...",
      processing: "Verarbeite...",
      listening: "Höre zu...",
      preparingInterview: "Interview wird vorbereitet...",
      interviewComplete: "Interview abgeschlossen"
    },
    messages: {
      typing: "KI-Interviewer tippt...",
      aiInterviewer: "KI-Interviewer",
      interviewee: "Befragte(r)",
      recording: "Sprachnachricht aufnehmen",
      welcome: "Hallo! Bitte lassen Sie mich wissen, wann Sie bereit sind zu beginnen.",
      loadError: "Hallo! Es gab ein Problem beim Laden des Interview-Projekts, aber Sie können weiterhin durch die Seite blättern oder versuchen zu aktualisieren.",
      startFailed: "Interview konnte nicht gestartet werden.",
      loadFailed: "Interview-Projekt konnte nicht geladen werden; bitte überprüfen Sie, ob der Link korrekt ist.",
      transcribing: "Transkribiere...",
      messageCount: "{{count}} Nachrichten",
      you: "Sie",
      interviewInProgress: "Audio-Interview läuft. Beginnen Sie zu sprechen...",
      clickToStart: "Klicken Sie \"Interview starten\", um das Gespräch zu beginnen."
    },
    fields: {
      name: "Name",
      age: "Alter",
      gender: "Geschlecht",
      occupation: "Beruf",
      education: "Bildungsniveau",
      contact: "Kontaktinformationen",
      platformId: "Plattform-ID (falls vorhanden)",
      notes: "Notizen"
    },
    name: "Name",
    age: "Alter",
    gender: "Geschlecht",
    education: "Bildung",
    occupation: "Beruf",
    contact: "Kontakt",
    notes: "Notizen",
    gender: {
      male: "Männlich",
      female: "Weiblich",
      other: "Andere"
    },
    male: "Männlich",
    female: "Weiblich",
    other: "Andere",
    consentText: "Ich stimme der Teilnahme an diesem Interview zu",
    recordingNotice: "Dieses Interview kann zu Forschungszwecken aufgezeichnet werden.",
    recordingActive: "Dieses Interview wird aufgezeichnet",
    startInterview: "Interview starten",
    sections: {
      interviewLog: "Interview-Protokoll",
      interviewConversation: "Interview-Gespräch"
    },
    welcome2: "Hallo, lassen Sie mich wissen, wenn Sie bereit sind, das Interview zu beginnen.",
    warnings: {
      timeRunningOut: "Warnung: Das Interview endet in 1 Minute",
      audioRecorded: "Bitte beachten Sie: Ihre Sprachantworten werden aufgezeichnet und gespeichert.",
      textOnly: "Ihre Antworten werden nur in Text transkribiert. Originale Sprachaufnahmen werden nicht gespeichert.",
      audioInterviewActive: "Audio-Interview aktiv: Die KI kann Sie sprechen hören. Keine Tasten drücken erforderlich - sprechen Sie einfach natürlich und die KI wird zuerst mit Sprache antworten, dann den Text anzeigen.",
      audioRecording: "📹 Audio-Aufnahme: Ihr Audio wird zu Forschungszwecken aufgezeichnet.",
      audioWillRecord: "⚠️ Dieses Interview wird Audio aufzeichnen. Das Starten des Interviews zeigt Ihre Zustimmung zur Aufzeichnung an."
    },
    timeUp: {
      title: "Interview-Zeitlimit erreicht",
      message: "Das Interview hat seine maximale Dauer von {{duration}} Minuten erreicht und wurde automatisch beendet."
    },
    info: {
      language: "Interview-Sprache: {{language}}",
      engineUsed: "Verwendete Transkriptions-Engine: {{engine}}"
    },
    transcriptionEngine: {
      confirmXunfei: "Xunfei für die Transkription verwenden? Präziser, aber langsamer. Klicken Sie auf OK für Xunfei oder auf Abbrechen, um bei Whisper zu bleiben (schneller, Standard)."
    },
    consent: {
      checkbox: "Ich stimme der Teilnahme an diesem Interview zu",
      description: "Durch das Ankreuzen dieser Box stimmen Sie der Teilnahme an diesem Forschungsinterview zu und erkennen an, dass Ihre Antworten aufgezeichnet und zu Forschungszwecken verwendet werden.",
      twinCheckbox: "Ich stimme zu, dass meine Daten zur Erstellung einer KI-Persona für zukünftige Forschung verwendet werden",
      twinDescription: "Dies ermöglicht es Forschern, eine digitale Version Ihrer Interviewantworten für Folgestudien zu erstellen. Ihre Identität bleibt anonym."
    },
    help: {
      microphonePermission: "Probleme beim Starten des Interviews? Überprüfen Sie, ob die Mikrofonberechtigung aktiviert ist. Suchen Sie nach dem Symbol in der Nähe der Website-URL in Ihrem Browser und klicken Sie darauf, um die Berechtigung zu erteilen. Bitte verwenden Sie nicht den Firefox-Browser."
    },
    errors: {
      realtimeNotAvailable: "Echtzeit-Audio nicht verfügbar, kann nicht mit Audio-Interview fortfahren",
      testFailed: "Test fehlgeschlagen",
      noAudioTracks: "Keine Audio-Spuren gefunden",
      micAccessFailed: "Mikrofonzugriff fehlgeschlagen",
      connectionError: "Verbindungsfehler aufgetreten",
      testError: "Testfehler",
      unknown: "Unbekannter Fehler"
    },
    audioTest: {
      title: "Audio- und Mikrofon-Test",
      steps: "Test-Schritte:",
      step1: "1. Mikrofonzugriff testen",
      step2: "2. Mit Audio-Service verbinden",
      step3: "3. KI-Assistenten-Sprache testen (Anweisungen hören)",
      step4: "4. Ihre Sprache testen (sprechen Sie, wenn angewiesen)",
      description: "Dieser Test stellt sicher, dass Ihr Mikrofon und Ihre Lautsprecher für das Sprachinterview korrekt funktionieren. Die KI wird zuerst sprechen und Sie dann bitten zu antworten. Audio-Tests sind erforderlich, um die beste Interview-Erfahrung zu gewährleisten.",
      testInProgress: "Test läuft...",
      startTest: "Audio-Test starten",
      retryTest: "Audio-Test wiederholen",
      testing: "Teste...",
      completed: "Test abgeschlossen",
      ready: "Bereit, Audio und Mikrofon zu testen",
      micAccess: "Teste Mikrofonzugriff...",
      connecting: "Session-Token abrufen...",
      establishing: "Mit Audio-Service verbinden...",
      aiSpeaking: "Verbindung hergestellt. Assistenten-Test starten...",
      userSpeak: "Assistent spricht. Bitte sagen Sie etwas, wenn Sie die Anweisung hören.",
      success: "Audio-Test erfolgreich! ✓ Mikrofon und Lautsprecher funktionieren korrekt.",
      startInterview: "Interview starten"
    },
    languages: {
      english: "Englisch",
      chinese: "Chinesisch",
      french: "Französisch",
      norwegian: "Norwegisch",
      dutch: "Niederländisch",
      german: "Deutsch",
      spanish: "Spanisch",
      portuguese: "Portugiesisch",
      japanese: "Japanisch",
      arabic: "Arabisch",
      flexible: "Flexibel"
    },
    voice: {
      enabled: "🔊 Sprachwiedergabe aktiviert. KI-Antworten werden vorgelesen.",
      playing: "🎵 KI spricht... (Klicken Sie \"Antwort starten\" zum Stoppen)",
      playButton: "🔊 Abspielen",
      playingButton: "🔊 Spielt ab",
      speaking: "🎵 Spricht..."
    },
    resume: {
      title: "Vorheriges Interview fortsetzen?",
      description: "Wir haben eine vorherige Interview-Session gefunden, die Sie fortsetzen können. Möchten Sie dort weitermachen, wo Sie aufgehört haben, oder ein neues Interview starten?",
      continue: "Dieses Interview fortsetzen",
      startNew: "Neues Interview starten"
    },
    hints: {
      recording: "🔴 Aufnahme läuft... Tippen Sie außerhalb des Gesprächs zum Stoppen",
      tapToSpeak: "👆 Tippen Sie außerhalb des Gesprächs zum Sprechen",
      typeBelow: "Geben Sie Ihre Antwort unten ein",
      aiThinking: "KI denkt nach...",
      aiSlowTip: "Dauert länger als gewöhnlich. Wenn die KI stecken bleibt, aktualisieren Sie die Seite — Ihr Fortschritt ist gespeichert.",
      keepSpeaking: "Sprechen Sie weiter... Pause wenn fertig",
      listenToAI: "🔊 Hören Sie dem KI-Interviewer zu...",
      processing: "⏳ Ihre Antwort wird verarbeitet...",
      readyToListen: "Bereit - sprechen Sie jederzeit los"
    },
    tips: {
      title: "💡 Tipps und Fehlerbehebung",
      recordingIssue: "Wenn die Aufnahme unerwartet stoppt, versuchen Sie, die Seite zu aktualisieren und das Interview fortzusetzen.",
      aiStuck: "Wenn die KI lange Zeit im Denkprozess zu hängen scheint, aktualisieren Sie die Seite, um die Verbindung wiederherzustellen.",
      refreshNote: "Hinweis: Ihr Fortschritt wird automatisch gespeichert, daher ist das Aktualisieren sicher."
    },
    voicePreTest: {
      title: "Geräteprüfung",
      subtitle: "Stellen wir sicher, dass Ihr Mikrofon funktioniert, bevor wir beginnen.",
      micTest: "Mikrofon",
      micTesting: "Zugriff wird geprüft...",
      micOk: "Mikrofon erkannt ✓",
      micError: "Kein Zugriff auf das Mikrofon. Prüfen Sie die Browserberechtigungen.",
      micIdle: "Warten...",
      tip: "Stellen Sie sicher, dass Sie in einer ruhigen Umgebung sind und deutlich sprechen.",
      retry: "Erneut versuchen",
      back: "Zurück",
      startInterview: "Interview starten",
      startAnyway: "▶ Trotzdem starten"
    },
    interactionModes: {
      voiceToVoice: "Stimme → Stimme",
      voiceToText: "Stimme → Text",
      textToVoice: "Text → Stimme",
      textToText: "Text → Text"
    },
    thankYou: {
      title: "Vielen Dank!",
      message: "Vielen Dank für Ihre Teilnahme an diesem Interview. Ihre Antworten wurden erfolgreich gespeichert.",
      saved: "Gespräch gespeichert",
      recorded: "{{count}} Nachrichten aufgezeichnet",
      duration: "Dauer: {{minutes}}m {{seconds}}s",
      returnHome: "Zurück zur Startseite"
    },
    csat: {
      title: "Wie war Ihre Erfahrung?",
      subtitle: "Ihr Feedback hilft uns, besser zu werden. Es dauert nur einen Moment.",
      stars: "Sterne",
      commentPlaceholder: "Möchten Sie etwas teilen? (optional)",
      submit: "Absenden",
      skip: "Überspringen",
      thanks: "Vielen Dank!",
      thanksDetail: "Ihr Feedback wurde gespeichert."
    },
    countdown: {
      warning: "Die Zeit ist fast um!",
      remaining: "verbleibend"
    }
  },
  es: {
    title: "Entrevista",
    note: "Por favor, haga clic en 'Iniciar respuesta' para comenzar a responder. Haga clic en 'Terminar respuesta' para enviar su respuesta. Haga clic en 'Terminar entrevista' para finalizar la entrevista.",
    basicInfo: "Información básica",
    controls: {
      startInterview: "Iniciar entrevista",
      endInterview: "Terminar entrevista",
      startAnswer: "Iniciar respuesta",
      endAnswer: "Terminar respuesta",
      recording: "Grabando...",
      skipForm: "Omitir formulario",
      starting: "Iniciando...",
      typeMessage: "Escriba su mensaje...",
      send: "Enviar",
      sending: "Enviando..."
    },
    video: {
      turnOn: "Encender cámara",
      turnOff: "Apagar vista previa de video",
      stopRecording: "Detener cámara"
    },
    status: {
      connectionLost: "Conexión perdida. Por favor, actualice la página e intente de nuevo.",
      elapsedTime: "Tiempo transcurrido",
      status: "Estado",
      mode: "Modo",
      audioInterview: "Entrevista de audio",
      connected: "Conectado",
      connecting: "Conectando...",
      ended: "Entrevista terminada",
      ready: "Listo",
      recording: "Grabando",
      transcribing: "Transcribiendo...",
      aiSpeaking: "IA hablando",
      recordingAudio: "Grabando audio",
      youAreSpeaking: "Usted está hablando...",
      aiIsSpeaking: "La IA está hablando...",
      processing: "Procesando...",
      listening: "Escuchando...",
      preparingInterview: "Preparando entrevista...",
      interviewComplete: "Entrevista completada"
    },
    messages: {
      typing: "El entrevistador IA está escribiendo...",
      aiInterviewer: "Entrevistador IA",
      interviewee: "Entrevistado(a)",
      recording: "Grabando mensaje de voz",
      welcome: "¡Hola! Por favor, hágame saber cuándo esté listo para comenzar.",
      loadError: "¡Hola! Hubo un problema cargando el proyecto de entrevista, pero puede continuar navegando la página o intentar actualizar.",
      startFailed: "No se pudo iniciar la entrevista.",
      loadFailed: "No se pudo cargar el proyecto de entrevista; por favor, verifique si el enlace es correcto.",
      transcribing: "Transcribiendo...",
      messageCount: "{{count}} mensajes",
      you: "Usted",
      interviewInProgress: "Entrevista de audio en progreso. Comience a hablar para iniciar...",
      clickToStart: "Haga clic en \"Iniciar entrevista\" para comenzar la conversación."
    },
    fields: {
      name: "Nombre",
      age: "Edad",
      gender: "Género",
      occupation: "Ocupación",
      education: "Nivel educativo",
      contact: "Información de contacto",
      platformId: "ID de plataforma (si aplica)",
      notes: "Notas"
    },
    name: "Nombre",
    age: "Edad",
    gender: "Género",
    education: "Educación",
    occupation: "Ocupación",
    contact: "Contacto",
    notes: "Notas",
    gender: {
      male: "Masculino",
      female: "Femenino",
      other: "Otro"
    },
    male: "Masculino",
    female: "Femenino",
    other: "Otro",
    consentText: "Consiento participar en esta entrevista",
    recordingNotice: "Esta entrevista puede ser grabada con fines de investigación.",
    recordingActive: "Esta entrevista está siendo grabada",
    startInterview: "Iniciar entrevista",
    sections: {
      interviewLog: "Registro de entrevista",
      interviewConversation: "Conversación de entrevista"
    },
    welcome2: "Hola, hágame saber si está listo para comenzar la entrevista.",
    warnings: {
      timeRunningOut: "Advertencia: La entrevista terminará en 1 minuto",
      audioRecorded: "Tenga en cuenta: Sus respuestas de voz serán grabadas y almacenadas.",
      textOnly: "Sus respuestas serán transcritas solo a texto. Las grabaciones de voz originales no se guardarán.",
      audioInterviewActive: "Entrevista de audio activa: La IA puede escucharlo hablar. No necesita presionar botones - simplemente hable naturalmente y la IA responderá primero con voz, luego mostrará el texto.",
      audioRecording: "📹 Grabación de audio: Su audio se está grabando con fines de investigación.",
      audioWillRecord: "⚠️ Esta entrevista grabará audio. Iniciar la entrevista indica su consentimiento para la grabación."
    },
    timeUp: {
      title: "Límite de tiempo de entrevista alcanzado",
      message: "La entrevista ha alcanzado su duración máxima de {{duration}} minutos y ha sido terminada automáticamente."
    },
    info: {
      language: "Idioma de entrevista: {{language}}",
      engineUsed: "Motor de transcripción utilizado: {{engine}}"
    },
    transcriptionEngine: {
      confirmXunfei: "¿Usar Xunfei para la transcripción? Es más preciso pero más lento. Haga clic en Aceptar para Xunfei o en Cancelar para seguir con Whisper (más rápido, predeterminado)."
    },
    consent: {
      checkbox: "Consiento participar en esta entrevista",
      description: "Al marcar esta casilla, acepta participar en esta entrevista de investigación y reconoce que sus respuestas serán grabadas y utilizadas con fines de investigación.",
      twinCheckbox: "Consiento que mis datos se utilicen para crear un personaje de IA para investigaciones futuras",
      twinDescription: "Esto permite a los investigadores crear una versión digital de sus respuestas de entrevista para estudios de seguimiento. Su identidad permanecerá anónima."
    },
    help: {
      microphonePermission: "¿Problemas para iniciar la entrevista? Verifique si el permiso del micrófono está habilitado. Busque el icono cerca de la URL del sitio web en su navegador y haga clic en él para otorgar permiso. Por favor, no use el navegador Firefox."
    },
    errors: {
      realtimeNotAvailable: "Audio en tiempo real no disponible, no se puede continuar con entrevista de audio",
      testFailed: "Prueba fallida",
      noAudioTracks: "No se encontraron pistas de audio",
      micAccessFailed: "Acceso al micrófono falló",
      connectionError: "Error de conexión ocurrido",
      testError: "Error de prueba",
      unknown: "Error desconocido"
    },
    audioTest: {
      title: "Prueba de audio y micrófono",
      steps: "Pasos de prueba:",
      step1: "1. Probar acceso al micrófono",
      step2: "2. Conectar al servicio de audio",
      step3: "3. Probar voz del asistente IA (escuchar instrucciones)",
      step4: "4. Probar su voz (hablar cuando se le indique)",
      description: "Esta prueba asegura que su micrófono y altavoces funcionen correctamente para la entrevista de voz. La IA hablará primero, luego le pedirá que responda. Las pruebas de audio son requeridas para asegurar la mejor experiencia de entrevista.",
      testInProgress: "Prueba en progreso...",
      startTest: "Iniciar prueba de audio",
      retryTest: "Reintentar prueba de audio",
      testing: "Probando...",
      completed: "Prueba completada",
      ready: "Listo para probar audio y micrófono",
      micAccess: "Probando acceso al micrófono...",
      connecting: "Obteniendo token de sesión...",
      establishing: "Conectando al servicio de audio...",
      aiSpeaking: "Conexión establecida. Iniciando prueba del asistente...",
      userSpeak: "El asistente está hablando. Por favor, diga algo cuando escuche la instrucción.",
      success: "¡Prueba de audio exitosa! ✓ Micrófono y altavoces funcionando correctamente.",
      startInterview: "Iniciar entrevista"
    },
    languages: {
      english: "Inglés",
      chinese: "Chino",
      french: "Francés",
      norwegian: "Noruego",
      dutch: "Holandés",
      german: "Alemán",
      spanish: "Español",
      portuguese: "Portugués",
      japanese: "Japonés",
      arabic: "Árabe",
      flexible: "Flexible"
    },
    voice: {
      enabled: "🔊 Reproducción de voz habilitada. Las respuestas de la IA se leerán en voz alta.",
      playing: "🎵 La IA está hablando... (Haga clic en \"Iniciar respuesta\" para detener)",
      playButton: "🔊 Reproducir",
      playingButton: "🔊 Reproduciendo",
      speaking: "🎵 Hablando..."
    },
    resume: {
      title: "¿Reanudar entrevista anterior?",
      description: "Encontramos una sesión de entrevista anterior que puede continuar. ¿Le gustaría reanudar donde se quedó o comenzar una nueva entrevista?",
      continue: "Continuar esta entrevista",
      startNew: "Iniciar nueva entrevista"
    },
    hints: {
      recording: "🔴 Grabando... Toque fuera de la conversación para detener",
      tapToSpeak: "👆 Toque fuera de la conversación para hablar",
      typeBelow: "Escriba su respuesta abajo",
      aiThinking: "La IA está pensando...",
      aiSlowTip: "Tarda más de lo habitual. Si la IA sigue bloqueada, actualice la página — su progreso está guardado.",
      keepSpeaking: "Siga hablando... pause cuando termine",
      listenToAI: "🔊 Escuche al entrevistador IA...",
      processing: "⏳ Procesando su respuesta...",
      readyToListen: "Listo - comience a hablar cuando quiera"
    },
    tips: {
      title: "💡 Consejos y solución de problemas",
      recordingIssue: "Si la grabación se detiene inesperadamente, intente actualizar la página y continuar la entrevista.",
      aiStuck: "Si la IA parece atascada pensando durante mucho tiempo, actualice la página para reconectar.",
      refreshNote: "Nota: Su progreso se guarda automáticamente, por lo que actualizar es seguro."
    },
    voicePreTest: {
      title: "Verificación de dispositivo",
      subtitle: "Verifiquemos que su micrófono funciona antes de comenzar.",
      micTest: "Micrófono",
      micTesting: "Verificando acceso...",
      micOk: "Micrófono detectado ✓",
      micError: "No se pudo acceder al micrófono. Verifique los permisos del navegador.",
      micIdle: "Esperando...",
      tip: "Asegúrese de estar en un entorno tranquilo y hablar claramente.",
      retry: "Reintentar",
      back: "Volver",
      startInterview: "Iniciar entrevista",
      startAnyway: "▶ Iniciar de todos modos"
    },
    interactionModes: {
      voiceToVoice: "Voz → Voz",
      voiceToText: "Voz → Texto",
      textToVoice: "Texto → Voz",
      textToText: "Texto → Texto"
    },
    thankYou: {
      title: "¡Gracias!",
      message: "Gracias por participar en esta entrevista. Sus respuestas se han guardado correctamente.",
      saved: "Conversación guardada",
      recorded: "{{count}} mensajes grabados",
      duration: "Duración: {{minutes}}m {{seconds}}s",
      returnHome: "Volver al inicio"
    },
    csat: {
      title: "¿Cómo fue tu experiencia?",
      subtitle: "Tus comentarios nos ayudan a mejorar. Solo toma un momento.",
      stars: "estrellas",
      commentPlaceholder: "¿Algo que te gustaría compartir? (opcional)",
      submit: "Enviar",
      skip: "Omitir",
      thanks: "¡Gracias!",
      thanksDetail: "Tus comentarios se han registrado."
    },
    countdown: {
      warning: "¡El tiempo se está acabando!",
      remaining: "restante"
    }
  },
  pt: {
    title: "Entrevista",
    note: "Por favor, clique em 'Iniciar Resposta' para começar a responder. Clique em 'Terminar Resposta' para enviar sua resposta. Clique em 'Encerrar Entrevista' para finalizar a entrevista.",
    basicInfo: "Informações Básicas",
    controls: {
      startInterview: "Iniciar Entrevista",
      endInterview: "Encerrar Entrevista",
      startAnswer: "Iniciar Resposta",
      endAnswer: "Terminar Resposta",
      recording: "Gravando...",
      skipForm: "Pular Formulário",
      starting: "Iniciando...",
      typeMessage: "Digite sua mensagem...",
      send: "Enviar",
      sending: "Enviando..."
    },
    video: {
      turnOn: "Ligar Câmera",
      turnOff: "Desligar Pré-visualização de Vídeo",
      stopRecording: "Parar Câmera"
    },
    status: {
      connectionLost: "Conexão perdida. Por favor, atualize a página e tente novamente.",
      elapsedTime: "Tempo Decorrido",
      status: "Status",
      mode: "Modo",
      audioInterview: "Entrevista por Áudio",
      connected: "Conectado",
      connecting: "Conectando...",
      ended: "Entrevista Encerrada",
      ready: "Pronto",
      recording: "Gravando",
      transcribing: "Transcrevendo...",
      aiSpeaking: "IA Falando",
      recordingAudio: "Gravando Áudio",
      youAreSpeaking: "Você está falando...",
      aiIsSpeaking: "A IA está falando...",
      processing: "Processando...",
      listening: "Ouvindo...",
      preparingInterview: "Preparando entrevista...",
      interviewComplete: "Entrevista Concluída"
    },
    messages: {
      typing: "O entrevistador IA está digitando...",
      aiInterviewer: "Entrevistador IA",
      interviewee: "Entrevistado(a)",
      recording: "Gravando mensagem de voz",
      welcome: "Olá! Por favor, me avise quando estiver pronto para começar.",
      loadError: "Olá! Houve um problema ao carregar o projeto de entrevista, mas você pode continuar navegando na página ou tentar atualizar.",
      startFailed: "Falha ao iniciar a entrevista.",
      loadFailed: "Falha ao carregar o projeto de entrevista; por favor, verifique se o link está correto.",
      transcribing: "Transcrevendo",
      messageCount: "{{count}} mensagens",
      you: "Você",
      interviewInProgress: "Entrevista por áudio em andamento. Comece a falar para iniciar...",
      clickToStart: "Clique em \"Iniciar Entrevista\" para começar a conversa."
    },
    fields: {
      name: "Nome",
      age: "Idade",
      gender: "Gênero",
      occupation: "Profissão",
      education: "Nível de Escolaridade",
      contact: "Informações de Contato",
      platformId: "ID da Plataforma (se houver)",
      notes: "Observações"
    },
    name: "Nome",
    age: "Idade",
    gender: "Gênero",
    education: "Educação",
    occupation: "Profissão",
    contact: "Contato",
    notes: "Observações",
    gender: {
      male: "Masculino",
      female: "Feminino",
      other: "Outro"
    },
    male: "Masculino",
    female: "Feminino",
    other: "Outro",
    consentText: "Eu consinto em participar desta entrevista",
    recordingNotice: "Esta entrevista pode ser gravada para fins de pesquisa.",
    recordingActive: "Esta entrevista está sendo gravada",
    startInterview: "Iniciar Entrevista",
    sections: {
      interviewLog: "Registro da Entrevista",
      interviewConversation: "Conversa da Entrevista"
    },
    welcome2: "Olá, por favor me avise quando estiver pronto para começar a entrevista.",
    warnings: {
      timeRunningOut: "Aviso: A entrevista terminará em 1 minuto",
      audioRecorded: "Atenção: Suas respostas de voz serão gravadas e armazenadas.",
      textOnly: "Suas respostas serão transcritas apenas para texto. As gravações de voz originais não serão armazenadas.",
      audioInterviewActive: "Entrevista por áudio ativa: A IA pode ouvir você falando. Não é necessário pressionar botões - apenas fale naturalmente e a IA responderá primeiro com voz, depois mostrará o texto.",
      audioRecording: "📹 Gravação de áudio: Seu áudio está sendo gravado para fins de pesquisa.",
      audioWillRecord: "⚠️ Esta entrevista gravará áudio. Iniciar a entrevista indica seu consentimento para a gravação."
    },
    timeUp: {
      title: "Limite de Tempo da Entrevista Atingido",
      message: "A entrevista atingiu sua duração máxima de {{duration}} minutos e foi encerrada automaticamente."
    },
    info: {
      language: "Idioma da entrevista: {{language}}",
      engineUsed: "Motor de transcrição utilizado: {{engine}}"
    },
    transcriptionEngine: {
      confirmXunfei: "Usar Xunfei para transcrição? É mais preciso, mas mais lento. Clique OK para Xunfei ou Cancelar para continuar com Whisper (mais rápido, padrão)."
    },
    consent: {
      checkbox: "Eu consinto em participar desta entrevista",
      description: "Ao marcar esta caixa, você concorda em participar desta entrevista de pesquisa e reconhece que suas respostas serão gravadas e utilizadas para fins de pesquisa.",
      twinCheckbox: "Consinto que meus dados sejam usados para criar uma persona de IA para pesquisas futuras",
      twinDescription: "Isso permite que os pesquisadores criem uma versão digital de suas respostas de entrevista para estudos de acompanhamento. Sua identidade permanecerá anônima."
    },
    help: {
      microphonePermission: "Tendo problemas para iniciar a entrevista? Verifique se a permissão do microfone está habilitada. Procure o ícone próximo à URL do site no seu navegador e clique nele para conceder permissão. Por favor, não use o navegador Firefox."
    },
    errors: {
      realtimeNotAvailable: "Áudio em tempo real não disponível, não é possível prosseguir com entrevista por áudio",
      testFailed: "Teste falhou",
      noAudioTracks: "Nenhuma faixa de áudio encontrada",
      micAccessFailed: "Acesso ao microfone falhou",
      connectionError: "Erro de conexão ocorreu",
      testError: "Erro no teste",
      unknown: "Erro desconhecido"
    },
    audioTest: {
      title: "Teste de Áudio e Microfone",
      steps: "Etapas do teste:",
      step1: "1. Testar acesso ao microfone",
      step2: "2. Conectar ao serviço de áudio",
      step3: "3. Testar fala do assistente IA (ouça as instruções)",
      step4: "4. Testar sua fala (fale quando instruído)",
      description: "Este teste garante que seu microfone e alto-falantes estejam funcionando corretamente para a entrevista por voz. A IA falará primeiro e depois pedirá que você responda. O teste de áudio é necessário para garantir a melhor experiência de entrevista.",
      testInProgress: "Teste em andamento...",
      startTest: "Iniciar Teste de Áudio",
      retryTest: "Repetir Teste de Áudio",
      testing: "Testando...",
      completed: "Teste Concluído",
      ready: "Pronto para testar áudio e microfone",
      micAccess: "Testando acesso ao microfone...",
      connecting: "Obtendo token de sessão...",
      establishing: "Conectando ao serviço de áudio...",
      aiSpeaking: "Conexão estabelecida. Iniciando teste do assistente...",
      userSpeak: "O assistente está falando. Por favor, diga algo quando ouvir a instrução.",
      success: "Teste de áudio bem-sucedido! ✓ Microfone e alto-falantes funcionando corretamente.",
      startInterview: "Iniciar entrevista"
    },
    languages: {
      english: "Inglês",
      chinese: "Chinês",
      french: "Francês",
      norwegian: "Norueguês",
      dutch: "Holandês",
      german: "Alemão",
      spanish: "Espanhol",
      portuguese: "Português",
      japanese: "Japonês",
      arabic: "Árabe",
      flexible: "Flexível"
    },
    voice: {
      enabled: "🔊 Reprodução de voz habilitada. As respostas da IA serão lidas em voz alta.",
      playing: "🎵 A IA está falando... (Clique em \"Iniciar Resposta\" para parar)",
      playButton: "🔊 Reproduzir",
      playingButton: "🔊 Reproduzindo",
      speaking: "🎵 Falando..."
    },
    resume: {
      title: "Retomar Entrevista Anterior?",
      description: "Encontramos uma sessão de entrevista anterior que você pode continuar. Gostaria de retomar de onde parou ou iniciar uma nova entrevista?",
      continue: "Continuar Esta Entrevista",
      startNew: "Iniciar Nova Entrevista"
    },
    hints: {
      recording: "🔴 Gravando... Toque fora da conversa para parar",
      tapToSpeak: "👆 Toque fora da conversa para falar",
      typeBelow: "Digite sua resposta abaixo",
      aiThinking: "A IA está pensando...",
      aiSlowTip: "Demorando mais que o normal. Se a IA ficar travada, atualize a página — seu progresso está salvo.",
      keepSpeaking: "Continue falando... pause quando terminar",
      listenToAI: "🔊 Ouça o entrevistador IA...",
      processing: "⏳ Processando sua resposta...",
      readyToListen: "Pronto - comece a falar a qualquer momento"
    },
    tips: {
      title: "💡 Dicas e Solução de Problemas",
      recordingIssue: "Se a gravação parar inesperadamente, tente atualizar a página e continuar a entrevista.",
      aiStuck: "Se a IA parecer travada pensando por muito tempo, atualize a página para reconectar.",
      refreshNote: "Nota: Seu progresso é salvo automaticamente, então atualizar é seguro."
    },
    voicePreTest: {
      title: "Verificação do Dispositivo",
      subtitle: "Vamos verificar se seu microfone está funcionando antes de começar.",
      micTest: "Microfone",
      micTesting: "Verificando acesso...",
      micOk: "Microfone detectado ✓",
      micError: "Não foi possível acessar o microfone. Verifique as permissões do navegador.",
      micIdle: "Aguardando...",
      tip: "Certifique-se de estar em um ambiente silencioso e fale claramente.",
      retry: "Tentar Novamente",
      back: "Voltar",
      startInterview: "Iniciar Entrevista",
      startAnyway: "▶ Iniciar Mesmo Assim"
    },
    interactionModes: {
      voiceToVoice: "Voz → Voz",
      voiceToText: "Voz → Texto",
      textToVoice: "Texto → Voz",
      textToText: "Texto → Texto"
    },
    thankYou: {
      title: "Obrigado!",
      message: "Obrigado por participar desta entrevista. Suas respostas foram salvas com sucesso.",
      saved: "Conversa salva",
      recorded: "{{count}} mensagens gravadas",
      duration: "Duração: {{minutes}}m {{seconds}}s",
      returnHome: "Voltar para Início"
    },
    csat: {
      title: "Como foi sua experiência?",
      subtitle: "Seu feedback nos ajuda a melhorar. Leva só um momento.",
      stars: "estrelas",
      commentPlaceholder: "Algo que gostaria de compartilhar? (opcional)",
      submit: "Enviar",
      skip: "Pular",
      thanks: "Obrigado!",
      thanksDetail: "Seu feedback foi registrado."
    },
    countdown: {
      warning: "O tempo está acabando!",
      remaining: "restante"
    }
  },
  ja: {
    title: "インタビュー",
    note: "「回答開始」をクリックして回答を始めてください。「回答終了」をクリックして回答を送信してください。「インタビュー終了」をクリックしてインタビューを終了してください。",
    basicInfo: "基本情報",
    controls: {
      startInterview: "インタビュー開始",
      endInterview: "インタビュー終了",
      startAnswer: "回答開始",
      endAnswer: "回答終了",
      recording: "録音中...",
      skipForm: "フォームをスキップ",
      starting: "開始中...",
      typeMessage: "メッセージを入力...",
      send: "送信",
      sending: "送信中..."
    },
    video: {
      turnOn: "カメラをオンにする",
      turnOff: "ビデオプレビューをオフにする",
      stopRecording: "カメラを停止する"
    },
    status: {
      connectionLost: "接続が失われました。ページを更新してもう一度お試しください。",
      elapsedTime: "経過時間",
      status: "ステータス",
      mode: "モード",
      audioInterview: "音声インタビュー",
      connected: "接続済み",
      connecting: "接続中...",
      ended: "インタビュー終了",
      ready: "準備完了",
      recording: "録音中",
      transcribing: "文字起こし中...",
      aiSpeaking: "AIが話しています",
      recordingAudio: "音声録音中",
      youAreSpeaking: "あなたが話しています...",
      aiIsSpeaking: "AIが話しています...",
      processing: "処理中...",
      listening: "聞いています...",
      preparingInterview: "インタビューを準備中...",
      interviewComplete: "インタビュー完了"
    },
    messages: {
      typing: "AIインタビュアーが入力中...",
      aiInterviewer: "AIインタビュアー",
      interviewee: "被インタビュー者",
      recording: "音声メッセージを録音中",
      welcome: "こんにちは！準備ができましたらお知らせください。",
      loadError: "こんにちは！インタビュープロジェクトの読み込みに問題がありましたが、ページの閲覧を続けるか、更新してみてください。",
      startFailed: "インタビューの開始に失敗しました。",
      loadFailed: "インタビュープロジェクトの読み込みに失敗しました。リンクが正しいか確認してください。",
      transcribing: "文字起こし中",
      messageCount: "{{count}} 件のメッセージ",
      you: "あなた",
      interviewInProgress: "音声インタビュー進行中。話し始めてください...",
      clickToStart: "「インタビュー開始」をクリックして会話を始めてください。"
    },
    fields: {
      name: "名前",
      age: "年齢",
      gender: "性別",
      occupation: "職業",
      education: "教育レベル",
      contact: "連絡先",
      platformId: "プラットフォームID（ある場合）",
      notes: "メモ"
    },
    name: "名前",
    age: "年齢",
    gender: "性別",
    education: "学歴",
    occupation: "職業",
    contact: "連絡先",
    notes: "メモ",
    gender: {
      male: "男性",
      female: "女性",
      other: "その他"
    },
    male: "男性",
    female: "女性",
    other: "その他",
    consentText: "このインタビューへの参加に同意します",
    recordingNotice: "このインタビューは研究目的で録音される場合があります。",
    recordingActive: "このインタビューは録音されています",
    startInterview: "インタビュー開始",
    sections: {
      interviewLog: "インタビューログ",
      interviewConversation: "インタビュー会話"
    },
    welcome2: "こんにちは、インタビューを始める準備ができましたらお知らせください。",
    warnings: {
      timeRunningOut: "警告：インタビューは1分後に終了します",
      audioRecorded: "ご注意：音声回答は録音・保存されます。",
      textOnly: "回答はテキストのみに文字起こしされます。元の音声録音は保存されません。",
      audioInterviewActive: "音声インタビュー中：AIはあなたの話を聞いています。ボタンを押す必要はありません - 自然に話すだけで、AIはまず音声で応答し、その後テキストを表示します。",
      audioRecording: "📹 音声録音：あなたの音声は研究目的で録音されています。",
      audioWillRecord: "⚠️ このインタビューは音声を録音します。インタビューを開始することは録音への同意を意味します。"
    },
    timeUp: {
      title: "インタビュー制限時間に達しました",
      message: "インタビューは最大時間{{duration}}分に達し、自動的に終了しました。"
    },
    info: {
      language: "インタビュー言語：{{language}}",
      engineUsed: "使用した文字起こしエンジン：{{engine}}"
    },
    transcriptionEngine: {
      confirmXunfei: "文字起こしにXunfeiを使用しますか？より正確ですが遅くなります。XunfeiはOKを、Whisper（より高速、デフォルト）を続けるにはキャンセルをクリックしてください。"
    },
    consent: {
      checkbox: "このインタビューへの参加に同意します",
      description: "このチェックボックスをオンにすることで、この研究インタビューに参加することに同意し、回答が記録され研究目的で使用されることを了承します。",
      twinCheckbox: "将来の研究のためにAIペルソナを作成するために私のデータを使用することに同意します",
      twinDescription: "これにより、研究者はフォローアップ研究のためにあなたのインタビュー回答のデジタルバージョンを作成できます。あなたの身元は匿名のままです。"
    },
    help: {
      microphonePermission: "インタビューの開始に問題がありますか？マイクの許可が有効になっているか確認してください。ブラウザのウェブサイトURL付近のアイコンを探してクリックし、許可を付与してください。Firefoxブラウザは使用しないでください。"
    },
    errors: {
      realtimeNotAvailable: "リアルタイム音声が利用できません。音声インタビューを続行できません",
      testFailed: "テスト失敗",
      noAudioTracks: "オーディオトラックが見つかりません",
      micAccessFailed: "マイクへのアクセスに失敗しました",
      connectionError: "接続エラーが発生しました",
      testError: "テストエラー",
      unknown: "不明なエラー"
    },
    audioTest: {
      title: "オーディオ＆マイクテスト",
      steps: "テスト手順：",
      step1: "1. マイクアクセスをテスト",
      step2: "2. オーディオサービスに接続",
      step3: "3. AIアシスタントの音声をテスト（指示を聞いてください）",
      step4: "4. あなたの音声をテスト（指示されたら話してください）",
      description: "このテストは、音声インタビューのためにマイクとスピーカーが正しく動作していることを確認します。AIが最初に話し、その後あなたに応答を求めます。最高のインタビュー体験を確保するために、オーディオテストが必要です。",
      testInProgress: "テスト中...",
      startTest: "オーディオテストを開始",
      retryTest: "オーディオテストを再試行",
      testing: "テスト中...",
      completed: "テスト完了",
      ready: "オーディオとマイクのテスト準備完了",
      micAccess: "マイクアクセスをテスト中...",
      connecting: "セッショントークンを取得中...",
      establishing: "オーディオサービスに接続中...",
      aiSpeaking: "接続確立。アシスタントテストを開始...",
      userSpeak: "アシスタントが話しています。指示が聞こえたら何か話してください。",
      success: "オーディオテスト成功！✓ マイクとスピーカーが正常に動作しています。",
      startInterview: "インタビューを開始"
    },
    languages: {
      english: "英語",
      chinese: "中国語",
      french: "フランス語",
      norwegian: "ノルウェー語",
      dutch: "オランダ語",
      german: "ドイツ語",
      spanish: "スペイン語",
      portuguese: "ポルトガル語",
      japanese: "日本語",
      arabic: "アラビア語",
      flexible: "フレキシブル"
    },
    voice: {
      enabled: "🔊 音声再生が有効です。AIの応答が読み上げられます。",
      playing: "🎵 AIが話しています...（「回答開始」をクリックして停止）",
      playButton: "🔊 再生",
      playingButton: "🔊 再生中",
      speaking: "🎵 話しています..."
    },
    resume: {
      title: "前回のインタビューを再開しますか？",
      description: "続行できる前回のインタビューセッションが見つかりました。中断したところから再開しますか、それとも新しいインタビューを開始しますか？",
      continue: "このインタビューを続ける",
      startNew: "新しいインタビューを開始"
    },
    hints: {
      recording: "🔴 録音中... 会話の外をタップして停止",
      tapToSpeak: "👆 会話の外をタップして話す",
      typeBelow: "下に回答を入力してください",
      aiThinking: "AIが考えています...",
      aiSlowTip: "通常より時間がかかっています。AIが止まったままの場合は、ページを更新してください — 進捗は保存されています。",
      keepSpeaking: "話し続けてください... 終わったら一時停止",
      listenToAI: "🔊 AIインタビュアーを聞いてください...",
      processing: "⏳ 回答を処理中...",
      readyToListen: "準備完了 - いつでも話し始めてください"
    },
    tips: {
      title: "💡 ヒントとトラブルシューティング",
      recordingIssue: "録音が予期せず停止した場合は、ページを更新してインタビューを続けてください。",
      aiStuck: "AIが長時間考え込んでいるように見える場合は、ページを更新して再接続してください。",
      refreshNote: "注意：進捗は自動的に保存されるので、更新しても安全です。"
    },
    voicePreTest: {
      title: "デバイスチェック",
      subtitle: "開始前にマイクが正常に動作しているか確認しましょう。",
      micTest: "マイク",
      micTesting: "アクセスを確認中...",
      micOk: "マイクが検出されました ✓",
      micError: "マイクにアクセスできませんでした。ブラウザの許可を確認してください。",
      micIdle: "待機中...",
      tip: "静かな環境で、はっきりと話してください。",
      retry: "再試行",
      back: "戻る",
      startInterview: "インタビュー開始",
      startAnyway: "▶ そのまま開始"
    },
    interactionModes: {
      voiceToVoice: "音声 → 音声",
      voiceToText: "音声 → テキスト",
      textToVoice: "テキスト → 音声",
      textToText: "テキスト → テキスト"
    },
    thankYou: {
      title: "ありがとうございます！",
      message: "このインタビューにご参加いただきありがとうございます。回答は正常に保存されました。",
      saved: "会話が保存されました",
      recorded: "{{count}} 件のメッセージが記録されました",
      duration: "所要時間：{{minutes}}分{{seconds}}秒",
      returnHome: "ホームに戻る"
    },
    csat: {
      title: "今回の体験はいかがでしたか？",
      subtitle: "ご意見はサービス改善に役立ちます。ほんの少しお時間をください。",
      stars: "つ星",
      commentPlaceholder: "ご意見・ご感想があればお聞かせください（任意）",
      submit: "送信",
      skip: "スキップ",
      thanks: "ありがとうございました！",
      thanksDetail: "ご意見を受け付けました。"
    },
    countdown: {
      warning: "時間がもうすぐ終了します！",
      remaining: "残り"
    }
  },
  ar: {
    title: "المقابلة",
    note: "يرجى النقر على 'بدء الإجابة' لبدء الرد. انقر على 'إنهاء الإجابة' لإرسال إجابتك. انقر على 'إنهاء المقابلة' لإنهاء المقابلة.",
    basicInfo: "المعلومات الأساسية",
    controls: {
      startInterview: "بدء المقابلة",
      endInterview: "إنهاء المقابلة",
      startAnswer: "بدء الإجابة",
      endAnswer: "إنهاء الإجابة",
      recording: "جارٍ التسجيل...",
      skipForm: "تخطي النموذج",
      starting: "جارٍ البدء...",
      typeMessage: "اكتب رسالتك...",
      send: "إرسال",
      sending: "جارٍ الإرسال..."
    },
    video: {
      turnOn: "تشغيل الكاميرا",
      turnOff: "إيقاف معاينة الفيديو",
      stopRecording: "إيقاف الكاميرا"
    },
    status: {
      connectionLost: "فُقد الاتصال. يرجى تحديث الصفحة والمحاولة مرة أخرى.",
      elapsedTime: "الوقت المنقضي",
      status: "الحالة",
      mode: "الوضع",
      audioInterview: "مقابلة صوتية",
      connected: "متصل",
      connecting: "جارٍ الاتصال...",
      ended: "انتهت المقابلة",
      ready: "جاهز",
      recording: "تسجيل",
      transcribing: "جارٍ النسخ...",
      aiSpeaking: "الذكاء الاصطناعي يتحدث",
      recordingAudio: "تسجيل الصوت",
      youAreSpeaking: "أنت تتحدث...",
      aiIsSpeaking: "الذكاء الاصطناعي يتحدث...",
      processing: "جارٍ المعالجة...",
      listening: "جارٍ الاستماع...",
      preparingInterview: "جارٍ تحضير المقابلة...",
      interviewComplete: "اكتملت المقابلة"
    },
    messages: {
      typing: "المحاور الذكي يكتب...",
      aiInterviewer: "المحاور الذكي",
      interviewee: "المُقابَل",
      recording: "تسجيل رسالة صوتية",
      welcome: "مرحباً! يرجى إخباري عندما تكون مستعداً للبدء.",
      loadError: "مرحباً! حدثت مشكلة في تحميل مشروع المقابلة، لكن يمكنك متابعة تصفح الصفحة أو محاولة التحديث.",
      startFailed: "فشل في بدء المقابلة.",
      loadFailed: "فشل في تحميل مشروع المقابلة؛ يرجى التحقق من صحة الرابط.",
      transcribing: "جارٍ النسخ",
      messageCount: "{{count}} رسائل",
      you: "أنت",
      interviewInProgress: "المقابلة الصوتية جارية. ابدأ بالتحدث للبدء...",
      clickToStart: "انقر على \"بدء المقابلة\" لبدء المحادثة."
    },
    fields: {
      name: "الاسم",
      age: "العمر",
      gender: "الجنس",
      occupation: "المهنة",
      education: "المستوى التعليمي",
      contact: "معلومات الاتصال",
      platformId: "معرف المنصة (إن وجد)",
      notes: "ملاحظات"
    },
    name: "الاسم",
    age: "العمر",
    gender: "الجنس",
    education: "التعليم",
    occupation: "المهنة",
    contact: "الاتصال",
    notes: "ملاحظات",
    gender: {
      male: "ذكر",
      female: "أنثى",
      other: "آخر"
    },
    male: "ذكر",
    female: "أنثى",
    other: "آخر",
    consentText: "أوافق على المشاركة في هذه المقابلة",
    recordingNotice: "قد يتم تسجيل هذه المقابلة لأغراض البحث.",
    recordingActive: "يتم تسجيل هذه المقابلة",
    startInterview: "بدء المقابلة",
    sections: {
      interviewLog: "سجل المقابلة",
      interviewConversation: "محادثة المقابلة"
    },
    welcome2: "مرحباً، يرجى إخباري عندما تكون مستعداً لبدء المقابلة.",
    warnings: {
      timeRunningOut: "تحذير: ستنتهي المقابلة خلال دقيقة واحدة",
      audioRecorded: "يرجى الملاحظة: سيتم تسجيل وتخزين ردودك الصوتية.",
      textOnly: "سيتم نسخ ردودك إلى نص فقط. لن يتم تخزين التسجيلات الصوتية الأصلية.",
      audioInterviewActive: "المقابلة الصوتية نشطة: يمكن للذكاء الاصطناعي سماعك تتحدث. لا حاجة للضغط على أي أزرار - فقط تحدث بشكل طبيعي وسيستجيب الذكاء الاصطناعي بالصوت أولاً، ثم يعرض النص.",
      audioRecording: "📹 تسجيل صوتي: يتم تسجيل صوتك لأغراض البحث.",
      audioWillRecord: "⚠️ ستقوم هذه المقابلة بتسجيل الصوت. بدء المقابلة يعني موافقتك على التسجيل."
    },
    timeUp: {
      title: "تم الوصول إلى الحد الزمني للمقابلة",
      message: "وصلت المقابلة إلى مدتها القصوى البالغة {{duration}} دقيقة وتم إنهاؤها تلقائياً."
    },
    info: {
      language: "لغة المقابلة: {{language}}",
      engineUsed: "محرك النسخ المستخدم: {{engine}}"
    },
    transcriptionEngine: {
      confirmXunfei: "هل تريد استخدام Xunfei للنسخ؟ أكثر دقة ولكن أبطأ. انقر موافق لـ Xunfei، أو إلغاء للبقاء مع Whisper (أسرع، افتراضي)."
    },
    consent: {
      checkbox: "أوافق على المشاركة في هذه المقابلة",
      description: "بتحديد هذا المربع، فإنك توافق على المشاركة في مقابلة البحث هذه وتقر بأن ردودك سيتم تسجيلها واستخدامها لأغراض البحث.",
      twinCheckbox: "أوافق على استخدام بياناتي لإنشاء شخصية ذكاء اصطناعي للأبحاث المستقبلية",
      twinDescription: "يتيح ذلك للباحثين إنشاء نسخة رقمية من إجاباتك في المقابلة لدراسات المتابعة. ستظل هويتك مجهولة."
    },
    help: {
      microphonePermission: "هل تواجه مشكلة في بدء المقابلة؟ تحقق مما إذا كان إذن الميكروفون مفعلاً. ابحث عن الأيقونة بالقرب من عنوان URL للموقع في متصفحك وانقر عليها لمنح الإذن. يرجى عدم استخدام متصفح Firefox."
    },
    errors: {
      realtimeNotAvailable: "الصوت في الوقت الفعلي غير متاح، لا يمكن متابعة المقابلة الصوتية",
      testFailed: "فشل الاختبار",
      noAudioTracks: "لم يتم العثور على مسارات صوتية",
      micAccessFailed: "فشل الوصول إلى الميكروفون",
      connectionError: "حدث خطأ في الاتصال",
      testError: "خطأ في الاختبار",
      unknown: "خطأ غير معروف"
    },
    audioTest: {
      title: "اختبار الصوت والميكروفون",
      steps: "خطوات الاختبار:",
      step1: "1. اختبار الوصول إلى الميكروفون",
      step2: "2. الاتصال بخدمة الصوت",
      step3: "3. اختبار صوت مساعد الذكاء الاصطناعي (استمع للتعليمات)",
      step4: "4. اختبار صوتك (تحدث عند التعليمات)",
      description: "يضمن هذا الاختبار أن الميكروفون ومكبرات الصوت تعمل بشكل صحيح للمقابلة الصوتية. سيتحدث الذكاء الاصطناعي أولاً، ثم يطلب منك الرد. اختبار الصوت مطلوب لضمان أفضل تجربة مقابلة.",
      testInProgress: "الاختبار جارٍ...",
      startTest: "بدء اختبار الصوت",
      retryTest: "إعادة اختبار الصوت",
      testing: "جارٍ الاختبار...",
      completed: "اكتمل الاختبار",
      ready: "جاهز لاختبار الصوت والميكروفون",
      micAccess: "جارٍ اختبار الوصول إلى الميكروفون...",
      connecting: "جارٍ الحصول على رمز الجلسة...",
      establishing: "جارٍ الاتصال بخدمة الصوت...",
      aiSpeaking: "تم إنشاء الاتصال. بدء اختبار المساعد...",
      userSpeak: "المساعد يتحدث. يرجى قول أي شيء عندما تسمع التعليمات.",
      success: "نجح اختبار الصوت! ✓ الميكروفون ومكبرات الصوت يعملان بشكل صحيح.",
      startInterview: "بدء المقابلة"
    },
    languages: {
      english: "الإنجليزية",
      chinese: "الصينية",
      french: "الفرنسية",
      norwegian: "النرويجية",
      dutch: "الهولندية",
      german: "الألمانية",
      spanish: "الإسبانية",
      portuguese: "البرتغالية",
      japanese: "اليابانية",
      arabic: "العربية",
      flexible: "مرن"
    },
    voice: {
      enabled: "🔊 تشغيل الصوت مفعل. سيتم قراءة ردود الذكاء الاصطناعي بصوت عالٍ.",
      playing: "🎵 الذكاء الاصطناعي يتحدث... (انقر على \"بدء الإجابة\" للإيقاف)",
      playButton: "🔊 تشغيل",
      playingButton: "🔊 قيد التشغيل",
      speaking: "🎵 يتحدث..."
    },
    resume: {
      title: "استئناف المقابلة السابقة؟",
      description: "وجدنا جلسة مقابلة سابقة يمكنك متابعتها. هل تود الاستئناف من حيث توقفت أم بدء مقابلة جديدة؟",
      continue: "متابعة هذه المقابلة",
      startNew: "بدء مقابلة جديدة"
    },
    hints: {
      recording: "🔴 جارٍ التسجيل... اضغط خارج المحادثة للإيقاف",
      tapToSpeak: "👆 اضغط خارج المحادثة للتحدث",
      typeBelow: "اكتب ردك أدناه",
      aiThinking: "الذكاء الاصطناعي يفكر...",
      aiSlowTip: "يستغرق وقتاً أطول من المعتاد. إذا ظل الذكاء الاصطناعي عالقاً، قم بتحديث الصفحة — تقدمك محفوظ.",
      keepSpeaking: "استمر في التحدث... توقف عند الانتهاء",
      listenToAI: "🔊 استمع إلى المحاور الذكي...",
      processing: "⏳ جارٍ معالجة ردك...",
      readyToListen: "جاهز - ابدأ التحدث في أي وقت"
    },
    tips: {
      title: "💡 نصائح واستكشاف الأخطاء",
      recordingIssue: "إذا توقف التسجيل بشكل غير متوقع، حاول تحديث الصفحة ومتابعة المقابلة.",
      aiStuck: "إذا بدا الذكاء الاصطناعي عالقاً في التفكير لفترة طويلة، قم بتحديث الصفحة لإعادة الاتصال.",
      refreshNote: "ملاحظة: يتم حفظ تقدمك تلقائياً، لذا التحديث آمن."
    },
    voicePreTest: {
      title: "فحص الجهاز",
      subtitle: "دعنا نتأكد من أن الميكروفون يعمل قبل أن نبدأ.",
      micTest: "الميكروفون",
      micTesting: "جارٍ فحص الوصول...",
      micOk: "تم اكتشاف الميكروفون ✓",
      micError: "تعذر الوصول إلى الميكروفون. تحقق من أذونات المتصفح.",
      micIdle: "في الانتظار...",
      tip: "تأكد من أنك في بيئة هادئة وتحدث بوضوح.",
      retry: "إعادة المحاولة",
      back: "رجوع",
      startInterview: "بدء المقابلة",
      startAnyway: "▶ البدء على أي حال"
    },
    interactionModes: {
      voiceToVoice: "صوت → صوت",
      voiceToText: "صوت → نص",
      textToVoice: "نص → صوت",
      textToText: "نص → نص"
    },
    thankYou: {
      title: "شكراً لك!",
      message: "شكراً لمشاركتك في هذه المقابلة. تم حفظ ردودك بنجاح.",
      saved: "تم حفظ المحادثة",
      recorded: "تم تسجيل {{count}} رسائل",
      duration: "المدة: {{minutes}}د {{seconds}}ث",
      returnHome: "العودة إلى الصفحة الرئيسية"
    },
    csat: {
      title: "كيف كانت تجربتك؟",
      subtitle: "ملاحظاتك تساعدنا على التحسين. لن يستغرق الأمر سوى لحظة.",
      stars: "نجوم",
      commentPlaceholder: "هل تودّ مشاركة شيء ما؟ (اختياري)",
      submit: "إرسال",
      skip: "تخطّي",
      thanks: "شكراً لك!",
      thanksDetail: "تم تسجيل ملاحظاتك."
    },
    countdown: {
      warning: "الوقت على وشك الانتهاء!",
      remaining: "متبقي"
    }
  }
};
